{
  "account.account": "Профил и безбедност",
  "account.accountDeleted": "Ваш налог је успешно избрисан.",
  "account.accountDescription": "Име, лозинка, брисање налога",
  "account.accountSection": "Налог",
  "account.changeEmail": "Промени е-пошту",
  "account.changePassword": "Промени лозинку",
  "account.currentPassword": "Тренутна лозинка",
  "account.dangerZone": "Ризична зона",
  "account.deleteAccount": "Обрисати налог",
  "account.deleteAccountConfirmation": "Да ли сте сигурни да желите да избришете свој налог? Ова акција је неповратна.",
  "account.deleteAccountDescription": "Ова радња брише ваш налог и све ваше информације. Нема повратка.",
  "account.emailChange": "Промени адресу е-поште",
  "account.emailChangeConfirmation": "Потврда промене е-поште",
  "account.emailChangeFailure": "Линк за промену е-поште је неважећи или је истекао.",
  "account.emailChangeIntro": "Унесите нову адресу е-поште и тренутну лозинку. Послаћемо линк на нову адресу: адреса е-поште ће се променити тек када га отворите.",
  "account.emailChangeSuccess": "Ваша е-пошта је успешно промењена у {newEmail}.",
  "account.emailChangeSuccessNoAddress": "Ваша адреса е-поште је успешно промењена.",
  "account.emailChangeVerificationSent": "Верификациони е-маил је послат на вашу нову адресу е-поште. Проверите своје пријемно сандуче и кликните на линк да потврдите промену.",
  "account.manageAccount": "Управљај налогом",
  "account.newEmailAddress": "Нова адреса е-поште",
  "account.newPassword": "Нова лозинка",
  "account.newPasswordAgain": "Поновите нову лозинку",
  "account.oldPassword": "Стара лозинка",
  "account.passwordChange": "Промена лозинке",
  "account.passwordChangeDescription": "Одржавајте свој налог безбедним",
  "account.passwordUpdated": "Лозинка је успешно промењена.",
  "account.profile": "Профил",
  "account.profileUpdated": "Профил је успешно ажуриран.",
  "account.signedInAs": "Пријављени као",
  "account.updateYourProfile": "Ажурирајте ваш профил",
  "account.updateYourProfileDescription": "Име и подешавања приказа",
  "addons.accountOnHold": "Веза вашег налога је истекла. Поново се повежите да бисте наставили ажурирање података.",
  "addons.accountOnHoldTitle": "Налог паузиран",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Креирајте и преузмите свој АПИ кључ са ове везе",
  "addons.ambientWeatherDescription": "Ambient Weather метеостанице (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "АПИ кључ",
  "addons.applicationKey": "Кључ апликације",
  "addons.availableServices": "Доступно",
  "addons.cannotDisconnectLastAccount": "Није могуће одспојити једини метод пријаве. Прво додајте други метод пријаве.",
  "addons.connect": "Повежи",
  "addons.connected": "Повезано",
  "addons.connectedAccounts": "Повезани налози",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedAccountsLoading": "Учитавање повезаних налога…",
  "addons.connectedServices": "Повезано",
  "addons.connectedSince": "Повезано од {date}",
  "addons.connectionSection": "Веза",
  "addons.connectionSuccess": "{provider} налог успешно повезан",
  "addons.davisApiSecret": "API тајни",
  "addons.davisApiV2Key": "V2 API кључ",
  "addons.davisDescription": "Davis метеостанице (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Прибавите ваш V2 API кључ са овог линка",
  "addons.disconnect": "Одспоји",
  "addons.disconnectConfirmation": "Да ли сте сигурни да желите одспојити {provider} налог?",
  "addons.disconnectEnergyConfirmation": "SmartMixin ће престати да синхронизује Netatmo Energy и уклониће ваше куће из апликације SmartMixin. Ваш Netatmo налог и уређаји неће бити погођени.",
  "addons.disconnectEnergyDescription": "Зауставља синхронизацију и уклања ваше куће из апликације SmartMixin.",
  "addons.disconnectionSuccess": "{provider} налог успешно одспојен",
  "addons.disconnectProviderDescription": "Зауставља синхронизацију и брише станице ове услуге и њихову историју.",
  "addons.disconnectServiceConfirmation": "SmartMixin ће престати да синхронизује услугу {provider} и избрисаће станице те услуге и целу њихову историју. Сам ваш налог на услузи {provider} неће бити погођен.",
  "addons.disconnectServiceTitle": "Одспојити услугу {provider}?",
  "addons.ecowittCreateAndRetrieveKeys": "Направите и преузмите свој АПИ кључ и кључ апликације са ове везе",
  "addons.ecowittDescription": "Ecowitt нуди професионалне метеоролошке станице, бежичне унутрашње/спољашње термометре, прецизне кишомере, сензоре квалитета ваздуха и још много тога.",
  "addons.helpLink": "Како повезати {provider}",
  "addons.integrationsSection": "Интеграције",
  "addons.myAcuriteAccountOnHold": "Ваш налог је стављен на чекање. Унесите лозинку да бисте поново повезали свој налог",
  "addons.myAcuriteDescription": "AcuRite је бренд метеоролошке станице број 1 у Северној Америци. Као лидер у технологији времена, температуре и временских прилика, AcuRite вам пружа детаљне информације о вашем унутрашњем и спољашњем окружењу тако да можете са поверењем да планирате свој дан.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Да промените температуру у кући, било из кревете било са друге стране света, користите ваш Netatmo Термостат.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Ваша лична метеоролошка станица",
  "addons.notConnected": "Није повезано",
  "addons.or": "или",
  "addons.providerAccountDisconnected": "Веза са вашом метеоролошком службом је истекла. Поново се повежите да бисте наставили ажурирање података.",
  "addons.reconnect": "Повежи поново",
  "addons.socialConnectionsIntro": "Повежите своје друштвене налоге за брзу пријаву. Можете повезивати или одспајати налоге у било ком тренутку.",
  "addons.weatherflowAccessToken": "Приступни токен",
  "addons.weatherflowCreateToken": "Направи и повуци токен са овог линка",
  "addons.weatherflowTempestDescription": "Tempest метеосистем са уграђеним сензором ветра, сензором кише",
  "addons.weatherServices": "Метеоролошке услуге",
  "addons.weatherServicesConnected": "{count, plural, =0 {Нема повезаних услуга} one {# повезана услуга} few {# повезане услуге} other {# повезаних услуга}}",
  "addons.weatherServicesDescription": "Повежите Netatmo, Davis, Weatherflow и остало",
  "addons.wundergroundApiKey": "АПИ кључ",
  "addons.wundergroundDescription": "Weather Underground је глобална заједница људи која повезује податке са сензора животне средине као што су метеоролошке станице и монитори квалитета ваздуха како бисмо могли да испоручимо богате, хиперлокалне податке који су вам потребни за подстицање ваших страсти.",
  "addons.wundergroundRemoveStationDescription": "Станица се уклања са вашег SmartMixin налога. Осим ако ју је додао и неки други SmartMixin налог, станица и историја коју је SmartMixin за њу забележио биће обрисани. На Weather Underground-у се ништа не мења.",
  "addons.wundergroundRemoveStationTitle": "Обрисати {station}?",
  "addons.wundergroundRetrieveApiKey": "Преузмите свој АПИ кључ са ове везе",
  "addons.wundergroundStationId": "ИД станице",
  "airQuality.adviceActivityGood": "Идеалан дан за кретање на отвореном",
  "airQuality.adviceActivityHazardous": "Избегавајте сваку физичку активност на отвореном",
  "airQuality.adviceActivityLabel": "Физичка активност",
  "airQuality.adviceActivityModerate": "Добар дан за кретање на отвореном",
  "airQuality.adviceActivitySensitive": "Размислите о краћим и мање интензивним активностима на отвореном",
  "airQuality.adviceActivityUnhealthy": "Смањите дуге или интензивне активности и правите више пауза",
  "airQuality.adviceActivityVeryUnhealthy": "Избегавајте дуге или интензивне активности; размислите о премештању у затворени простор",
  "airQuality.adviceGroupsGood": "Нису потребне посебне мере опреза",
  "airQuality.adviceGroupsHazardous": "Останите у затвореном простору и смањите активност",
  "airQuality.adviceGroupsLabel": "Осетљиве групе",
  "airQuality.adviceGroupsModerate": "Посебно осетљиве особе: краће и мање интензивне активности",
  "airQuality.adviceGroupsSensitive": "Краће и мање интензивне активности на отвореном, уз више пауза",
  "airQuality.adviceGroupsUnhealthy": "Избегавајте дуге или интензивне активности на отвореном; размислите о премештању у затворени простор",
  "airQuality.adviceGroupsVeryUnhealthy": "Избегавајте сваку физичку активност на отвореном; одложите је или преместите у затворени простор",
  "airQuality.adviceTimingLabel": "Када изаћи напоље",
  "airQuality.adviceTimingMorning": "Најбоље ујутру — тада је ниво озона нижи",
  "airQuality.airQuality": "Квалитет ваздуха",
  "airQuality.airQualityIndex": "Индекс квалитета ваздуха",
  "airQuality.aqiForecast": "Прогноза квалитета ваздуха",
  "airQuality.co2Fresh": "Свеж",
  "airQuality.co2GettingStale": "Благо загушљив",
  "airQuality.co2Stale": "Загушљив",
  "airQuality.dailyForecast": "Дневна прогноза",
  "airQuality.dominantPollutant": "Доминантни загађивач",
  "airQuality.expectedPeak": "Очекивани врхунац",
  "airQuality.good": "Добро",
  "airQuality.goodDescription": "Квалитет ваздуха је задовољавајући и загађеност ваздуха представља малу опасност.",
  "airQuality.hazardous": "Опасно",
  "airQuality.hazardousDescription": "Здравствено упозорење: све особе су под ризиком озбиљних здравствених симптома.",
  "airQuality.indoorAirQuality": "Квалитет ваздуха у затвореном простору",
  "airQuality.moderate": "Умерено",
  "airQuality.moderateDescription": "Квалитет ваздуха је прихватљив; ипак мањем броју људи који су изразито осетљиви на загађење ваздуха, поједини полутанти могу изазвати тегобе",
  "airQuality.noForecastForLocation": "За ову локацију није доступна прогноза квалитета ваздуха.",
  "airQuality.now": "Сада",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Загађујуће материје",
  "airQuality.recommendations": "Препоруке",
  "airQuality.sensitiveUnhealthy": "Нездраво за осетљиве групе",
  "airQuality.sensitiveUnhealthyDescription": "Јако осетљиве особе могу осетити тегобе. Просечна здрава особа неће имати проблем.",
  "airQuality.subIndex": "AQI подиндекс",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Разумевање индекса",
  "airQuality.unhealthy": "Нездраво",
  "airQuality.unhealthyDescription": "Сви ће да осете тегобе. Јако осетљиве особе могу да имају израженије симптоме.",
  "airQuality.veryUnhealthy": "Веома нездраво",
  "airQuality.veryUnhealthyDescription": "Здравствено упозорење о ванредном стању. Вероватно ће бити погођено цело становништво.",
  "alerts.addAlert": "Додај обавештење",
  "alerts.addCondition": "Додај услов",
  "alerts.alertAdded": "Обавештење успешно додато",
  "alerts.alertAuthorizationNotice": "Обавештења ће радити само ако овластите SmartMixin да приказује обавештења",
  "alerts.alertDeleted": "Обавештење успешно обрисано",
  "alerts.alertName": "Назив обавештења",
  "alerts.alertWhen": "Желим да будем обавештен кад:",
  "alerts.aqiGreaterThan": "AQI већи од",
  "alerts.aqiGreaterThanThreshold": "AQI већи од {value}{unit}",
  "alerts.aqiLessThan": "AQI мањи од",
  "alerts.aqiLessThanThreshold": "AQI мањи од {value}{unit}",
  "alerts.atLeastOneCondition": "Морате додати барем један услов",
  "alerts.co2GreaterThan": "Концентрација CO2 већа од",
  "alerts.co2GreaterThanThreshold": "Концентрација CO2 већа од {value}{unit}",
  "alerts.co2LessThan": "Концентрација CO2 мања од",
  "alerts.co2LessThanThreshold": "Концентрација CO2 мања од {value}{unit}",
  "alerts.conditions": "Услови",
  "alerts.conditionsDroppedOnStationChange": "Ова станица не подржава, уклоњено: {conditions}",
  "alerts.createAlert": "Направи обавештење",
  "alerts.dailyPrecipitationGreaterThan": "Дневне падавине веће од",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Дневне падавине изнад прага од {value}{unit}",
  "alerts.deleteAlert": "Обриши обавештење",
  "alerts.editAlert": "Уреди обавештење",
  "alerts.editCondition": "Уреди услов",
  "alerts.gustSpeedGreaterThan": "Удари ветра јачи од",
  "alerts.gustSpeedGreaterThanThreshold": "Удари ветра су јачи од {value}{unit}",
  "alerts.gustSpeedLessThan": "Удари ветра су мањи од",
  "alerts.gustSpeedLessThanThreshold": "Удари ветра су мањи од {value}{unit}",
  "alerts.heatIndexGreaterThan": "Индекс топлоте већи од",
  "alerts.heatIndexGreaterThanThreshold": "Индекс топлоте већи од {value}{unit}",
  "alerts.heatIndexLessThan": "Индекс топлоте мањи од",
  "alerts.heatIndexLessThanThreshold": "Индекс топлоте мањи од {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex већи од",
  "alerts.humidexGreaterThanThreshold": "Humidex већи од {value}{unit}",
  "alerts.humidexLessThan": "Humidex мањи од",
  "alerts.humidexLessThanThreshold": "Humidex мањи од {value}{unit}",
  "alerts.humidityGreaterThan": "Влажност ваздуха је већа од",
  "alerts.humidityGreaterThanThreshold": "Влажност ваздуха је већа од {value}{unit}",
  "alerts.humidityLessThan": "Влажност ваздуха је мања од",
  "alerts.humidityLessThanThreshold": "Влажност ваздуха је мања од {value}{unit}",
  "alerts.inProgress": "У току",
  "alerts.leafWetnessGreaterThan": "Влажност листова је већа од",
  "alerts.leafWetnessGreaterThanThreshold": "Влажност листова је већа од {value}{unit}",
  "alerts.leafWetnessLessThan": "Влажност листова је мања од",
  "alerts.leafWetnessLessThanThreshold": "Влажност листова је мања од {value}{unit}",
  "alerts.myAlerts": "Моја обавештења",
  "alerts.noConfiguredAlert": "Нисте до сада направили нити једно обавештење, почните тако што ћете га направити",
  "alerts.noiseGreaterThan": "Бука је јача од",
  "alerts.noiseGreaterThanThreshold": "Бука је јача од {value}{unit}",
  "alerts.noiseLessThan": "Бука је тиша од",
  "alerts.noiseLessThanThreshold": "Бука је тиша од {value}{unit}",
  "alerts.noteOnConditions": "Имајте на уму да је ово обавештење активирано када се испуне сви услови испод",
  "alerts.noTriggerHistory": "Ово упозорење још није активирано.",
  "alerts.pm10GreaterThan": "PM 10 веће од",
  "alerts.pm10GreaterThanThreshold": "PM 10 веће од {value}{unit}",
  "alerts.pm10LessThan": "PM 10 мање од",
  "alerts.pm10LessThanThreshold": "PM 10 мање од {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 веће од",
  "alerts.pm1GreaterThanThreshold": "PM 1 веће од {value}{unit}",
  "alerts.pm1LessThan": "PM 1 мање од",
  "alerts.pm1LessThanThreshold": "PM 1 мање од {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 веће од",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 веће од {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 мање од",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 мање од {value}{unit}",
  "alerts.postStormSummary": "Резиме након падавина",
  "alerts.postStormSynopsisHelper": "Добићете обавештење са резимеом након сваке кише.",
  "alerts.postStormSynopsisSoleCondition": "Резиме након падавина не може се комбиновати са другим условима.",
  "alerts.precipitationGreaterThan": "Часовне падавине веће од",
  "alerts.precipitationGreaterThanThreshold": "Часовне падавине изнад прага од {value}{unit}",
  "alerts.pressureGreaterThan": "Ваздушни притисак изнад",
  "alerts.pressureGreaterThanThreshold": "Ваздушни притисак изнад {value}{unit}",
  "alerts.pressureLessThan": "Ваздушни притисак испод",
  "alerts.pressureLessThanThreshold": "Ваздушни притисак нижи од {value}{unit}",
  "alerts.rainRateGreaterThan": "Интензитет кише већи од",
  "alerts.rainRateGreaterThanThreshold": "Интензитет кише изнад прага од {value}{unit}",
  "alerts.sensorNotReporting": "Овај сензор тренутно не шаље податке. Обавештење ће се наставити када поново почне да шаље.",
  "alerts.soilMoistureGreaterThan": "Влажност земљишта је већа од",
  "alerts.soilMoistureGreaterThanThreshold": "Влажност земљишта је већа од {value}{unit}",
  "alerts.soilMoistureLessThan": "Влажност земљишта је мања од",
  "alerts.soilMoistureLessThanThreshold": "Влажност земљишта је мања од {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Осунчаност већа од",
  "alerts.solarRadiationGreaterThanThreshold": "Осунчаност већа од {value}{unit}",
  "alerts.solarRadiationLessThan": "Осунчаност мања од",
  "alerts.solarRadiationLessThanThreshold": "Осунчаност мања од {value}{unit}",
  "alerts.stationNoLongerReports": "Ова станица више не шаље податке, па се ово обавештење не може активирати.",
  "alerts.stormChartUnavailable": "Историја кише за ове падавине није доступна.",
  "alerts.stormDetail": "Резиме падавина",
  "alerts.stormDuration": "Трајање",
  "alerts.stormEnd": "Крај",
  "alerts.stormPeakRate": "Највећи интензитет кише",
  "alerts.stormStart": "Почетак",
  "alerts.stormTotal": "Укупне падавине",
  "alerts.temperatureGreaterThan": "Температура виша од",
  "alerts.temperatureGreaterThanThreshold": "Температура виша од {value}{unit}",
  "alerts.temperatureLessThan": "Температура нижа од",
  "alerts.temperatureLessThanThreshold": "Температура нижа од {value}{unit}",
  "alerts.thresholdOutOfRange": "Мора бити између {min} и {max}",
  "alerts.thswGreaterThan": "THSW већи од",
  "alerts.thswGreaterThanThreshold": "THSW већи од {value}{unit}",
  "alerts.thswLessThan": "THSW мањи од",
  "alerts.thswLessThanThreshold": "THSW мањи од {value}{unit}",
  "alerts.thwGreaterThan": "THW већи од",
  "alerts.thwGreaterThanThreshold": "THW већи од {value}{unit}",
  "alerts.thwLessThan": "THW мањи од",
  "alerts.thwLessThanThreshold": "THW мањи од {value}{unit}",
  "alerts.triggerHistory": "Историја упозорења",
  "alerts.uvGreaterThan": "UV индекс већи од",
  "alerts.uvGreaterThanThreshold": "UV индекс већи од {value}{unit}",
  "alerts.uvLessThan": "UV индекс мањи од",
  "alerts.uvLessThanThreshold": "UV индекс мањи од {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Видљивост већа од {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Видљивост мања од {value}{unit}",
  "alerts.visiblityGreaterThan": "Видљивост већа од",
  "alerts.visiblityLessThan": "Видљивост мања од",
  "alerts.whichMeasure": "За која мерења желите да примате обавештења?",
  "alerts.whichModule": "За који модул бисте желели да будете упозорени?",
  "alerts.whichSensor": "За који сензор бисте желели да будете упозорени?",
  "alerts.windChillGreaterThan": "Осећај хладноће већи од",
  "alerts.windChillGreaterThanThreshold": "Осећај хладноће већи од {value}{unit}",
  "alerts.windChillLessThan": "Осећај хладноће мањи од",
  "alerts.windChillLessThanThreshold": "Осећај хладноће мањи од {value}{unit}",
  "alerts.windSpeedGreaterThan": "Брзина ветра већа од",
  "alerts.windSpeedGreaterThanThreshold": "Брзина ветра већа од {value}{unit}",
  "alerts.windSpeedLessThan": "Брзина ветра мања од",
  "alerts.windSpeedLessThanThreshold": "Брзина ветра мања од {value}{unit}",
  "appUpdate.updateAvailable": "Доступно је ажурирање",
  "appUpdate.updateAvailableOpenAppStore": "Додирните да отворите App Store",
  "appUpdate.updateAvailableOpenGooglePlay": "Додирните да отворите Google Play",
  "appUpdate.updateAvailableVersion": "Доступно је ажурирање: v{version}",
  "appUpdate.upgradeRequiredAndroid": "Потребна је надоградња апликације. Посетите Google Play ради надоградње.",
  "appUpdate.upgradeRequiredIos": "Потребна је надоградња апликације. Посетите App Store ради надоградње.",
  "astral.aboveHorizonAllDay": "Цео дан изнад хоризонта",
  "astral.aboveTheHorizon": "изнад хоризонта",
  "astral.apparentSize": "Привидни пречник",
  "astral.apparentSizeAcross": "{size} у пречнику",
  "astral.astronomicalDawn": "Астрономска зора",
  "astral.astronomicalDusk": "Астрономски сумрак",
  "astral.belowHorizonAllDay": "Цео дан испод хоризонта",
  "astral.belowHorizonSince": "Испод хоризонта од {time}",
  "astral.belowHorizonSinceOn": "Испод хоризонта од {day} {time}",
  "astral.brightAllNight": "Светло целе ноћи — никад потпуно мрачно",
  "astral.brightestMoment": "Најсветлији тренутак",
  "astral.civilDawn": "Грађанска зора",
  "astral.civilDusk": "Грађански сумрак",
  "astral.darkSkyBetween": "Тамно небо {from} → {to}",
  "astral.darkSkyWindow": "Тамно небо {from} → {to} · {duration} без Месеца",
  "astral.dayLength": "Дужина дана",
  "astral.daylightThroughTheYear": "Дужина дана током године",
  "astral.dayOfCycle": "дан {day} од {total}",
  "astral.doesNotOccurToday": "Данас се не дешава",
  "astral.domeHint": "Превуците за кретање кроз ноћ",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Најранији излазак сунца",
  "astral.earliestSunset": "Најранији залазак сунца",
  "astral.equinox": "Равнодневница",
  "astral.equinoxIn": "Равнодневница за {days, plural, one {# дан} few {# дана} other {# дана}}",
  "astral.evening": "Вече",
  "astral.exactPhaseAt": "Тачно у {time}",
  "astral.firstQuarter": "Прва четврт",
  "astral.firstSunriseIn": "Први излазак сунца за {days, plural, one {# дан} few {# дана} other {# дана}}",
  "astral.firstSunsetIn": "Први залазак сунца за {days, plural, one {# дан} few {# дана} other {# дана}}",
  "astral.fullMoon": "Пун месец",
  "astral.goldenHourBegins": "Почетак златног сата",
  "astral.goldenHourEnds": "Крај златног сата",
  "astral.highestPoint": "Највиша тачка",
  "astral.inDays": "за {days, plural, one {# дан} few {# дана} other {# дана}}",
  "astral.lastQuarter": "Последња четврт",
  "astral.latestSunrise": "Најкаснији излазак сунца",
  "astral.latestSunset": "Најкаснији залазак сунца",
  "astral.litShort": "Осветљ.",
  "astral.longestDay": "Најдужи дан",
  "astral.lowestPoint": "Најнижа тачка",
  "astral.maxAltitudeShort": "Макс.",
  "astral.midday": "Подне",
  "astral.midnightSun": "Поноћно сунце",
  "astral.midnightSunPeriod": "Поноћно сунце",
  "astral.milestoneFootnotePolar": "Овде сунце {days, plural, one {# дан} few {# дана} other {# дана}} у години нити излази нити залази, па списак уместо уобичајених крајности изласка и заласка показује када се то дешава.",
  "astral.milestoneFootnoteTemperate": "Најранији залазак и најкаснији излазак не падају на најкраћи дан — та два датума одређује једначина времена, а не солстициј.",
  "astral.moon": "Месец",
  "astral.moonAltitude": "Висина",
  "astral.moonDirection": "Азимут",
  "astral.moonDistance": "Удаљеност",
  "astral.moonlessFor": "{duration} без Месеца",
  "astral.moonPhases": "Месечеве фазе",
  "astral.moonrise": "Излазак месеца",
  "astral.moonset": "Залазак месеца",
  "astral.moonUpAllNight": "Месец је изнад хоризонта целе ноћи",
  "astral.moonWashesOutNight": "Месец је изнад хоризонта од {rise} до {set} и осветљава целу ноћ",
  "astral.morning": "Јутро",
  "astral.nauticalDawn": "Наутичка зора",
  "astral.nauticalDusk": "Наутички сумрак",
  "astral.newMoon": "Млад месец",
  "astral.nextDay": "+1 дан",
  "astral.nextProperlyDarkNight": "Следећа заиста тамна ноћ",
  "astral.nextRise": "следећи излазак у {time}",
  "astral.nextRiseOn": "следећи излазак {day} у {time}",
  "astral.nextSevenNights": "Следећих седам ноћи",
  "astral.nightDate": "Датум",
  "astral.noAstronomicalDarknessTonight": "Ноћас нема астрономске таме",
  "astral.noDarkNightAhead": "Нема је у наредне две недеље",
  "astral.noStationLocation": "Непозната локација",
  "astral.noStationLocationDescription": "Ова станица нема забележену позицију, па се за њу не могу израчунати Сунце и Месец.",
  "astral.noSunriseToday": "Данас нема изласка сунца",
  "astral.nowAtBearing": "сада {altitude} · азимут {direction}",
  "astral.observing": "Посматрање",
  "astral.ofDaylightLeft": "дневног светла преостало",
  "astral.overTheNextThreeWeeks": "током наредне 3 недеље",
  "astral.percentLit": "{percent} осветљено",
  "astral.polarNight": "Поларна ноћ",
  "astral.polarNightPeriod": "Поларна ноћ",
  "astral.rightNow": "Управо сада",
  "astral.riseShort": "Излазак",
  "astral.setShort": "Залазак",
  "astral.shortestDay": "Најкраћи дан",
  "astral.solarNoon": "Право подне",
  "astral.solstice": "Солстициј",
  "astral.sunBelowHorizon": "Сунце {degrees}° испод хоризонта",
  "astral.sunEvents": "Сунчеви догађаји",
  "astral.sunNeverDarkEnough": "Сунце никад не пада 18° испод хоризонта",
  "astral.sunNeverSets": "Сунце не залази",
  "astral.sunrise": "Излазак сунца",
  "astral.sunriseAndSunset": "Излазак и залазак сунца",
  "astral.sunriseAt": "Излазак сунца у {time}",
  "astral.sunset": "Залазак сунца",
  "astral.sunsetAt": "Залазак сунца у {time}",
  "astral.thisYearAtNorth": "Ове године на {degrees}° северне ширине",
  "astral.thisYearAtSouth": "Ове године на {degrees}° јужне ширине",
  "astral.tonight": "Ноћас",
  "astral.twilightAllNight": "Сумрак целе ноћи — никад потпуно мрачно",
  "astral.upFor": "{duration} изнад хоризонта",
  "astral.usableLight": "Искористива светлост",
  "astral.vsAverage": "{percent} од просека",
  "astral.vsYesterday": "у односу на јуче",
  "astral.waningCrescent": "Опадајући срп",
  "astral.waningGibbous": "Опадајући месец",
  "astral.waxingCrescent": "Растући срп",
  "astral.waxingGibbous": "Растући месец",
  "astral.whereToLook": "Где гледати",
  "astral.withoutTheMoon": "{duration} без Месеца",
  "auth.alreadyHaveAccount": "Већ имате налог?",
  "auth.authContainerTagline": "Ваша лична временска табла. Повежите своје станице и добијте податке у реалном времену надохват руке.",
  "auth.backToLogin": "Назад на пријаву",
  "auth.checkYourEmail": "Проверите своју е-пошту",
  "auth.continueWithApple": "Наставите са Apple",
  "auth.continueWithFacebook": "Наставите са Facebook",
  "auth.continueWithGoogle": "Наставите са Google",
  "auth.email": "Адреса е-поште",
  "auth.emailRequiredLoginFacebook": "Потребна је дозвола за приступ адреси е-поште.",
  "auth.emailVerification": "Верификација е-поште",
  "auth.emailVerificationFailure": "Десио се проблем са верификацијом путем е-поште.",
  "auth.emailVerificationSuccess": "Ваша адреса е-поште је успешно верификована.",
  "auth.firstName": "Име",
  "auth.forgotPassword": "Заборавили сте лозинку?",
  "auth.forgotPasswordSubtitle": "Унесите своју е-пошту и послаћемо вам линк за ресетовање лозинке.",
  "auth.lastName": "Презиме",
  "auth.login": "Пријави се",
  "auth.loginSubtitle": "Добродошли назад! Молимо унесите своје податке.",
  "auth.loginToSmartMixinDescription": "Пријавите се на SmartMixin да бисте приступили својим метеоролошким станицама, прегледали анализе и управљали личном временском таблом.",
  "auth.logout": "Одјави се",
  "auth.logoutConfirmation": "Да ли желите да се одјавите?",
  "auth.noAccountYet": "Још немате налог?",
  "auth.or": "или",
  "auth.password": "Лозинка",
  "auth.passwordReset": "Ресет лозинке",
  "auth.passwordResetSuccess": "Ваша лозинка је успешно промењена.",
  "auth.register": "Креирај налог",
  "auth.registerDescription": "Направите бесплатан SmartMixin налог за повезивање ваших метеоролошких станица, праћење временских података и приступ напредним аналитичким алатима.",
  "auth.registerSubtitle": "Креирајте свој налог да бисте започели.",
  "auth.restorePassword": "Поврати лозинку",
  "auth.restorePasswordSuccess": "Управо смо вам послали линк за ресет лозинке на {emailAddress} са детаљнијим инструкцијама.",
  "auth.sendReset": "Пошаљи инструкције за ресет",
  "auth.signInWithApple": "Пријава преко Apple налога",
  "auth.socialAccount": "или користите ваш налог",
  "auth.staffVerificationCode": "Код за потврду",
  "auth.staffVerificationExpiresIn": "Потврђено. Истиче за {duration}.",
  "auth.staffVerificationInvalidCode": "Нетачан код. Покушајте поново.",
  "auth.staffVerificationLoginAsStopped": "Login As је заустављен: унесите код за потврду на екрану Debug да бисте наставили.",
  "auth.staffVerificationNotEnrolled": "За ваш налог није подешена апликација за аутентификацију. Додајте је у безбедносним подешавањима администрације.",
  "auth.staffVerificationPrompt": "Унесите шестоцифрени код из апликације за аутентификацију или код за опоравак да бисте користили Login As и претрагу корисника.",
  "auth.staffVerificationSetupLink": "Додај апликацију за аутентификацију",
  "auth.staffVerificationSubmit": "Потврди",
  "auth.staffVerificationTitle": "Провера особља",
  "calendar.afternoon": "Поподне",
  "calendar.april": "Април",
  "calendar.august": "Август",
  "calendar.changePeriod": "Период: {period}. Промени период",
  "calendar.currentDay": "Данас",
  "calendar.dateFormat": "Формат датума",
  "calendar.day": "Дан",
  "calendar.december": "Децембар",
  "calendar.durationHours": "{hours} ч",
  "calendar.durationHoursMinutes": "{hours} ч {minutes} мин",
  "calendar.durationMinutes": "{minutes} мин",
  "calendar.durationMinutesSeconds": "{minutes} мин {seconds} с",
  "calendar.durationSeconds": "{seconds} с",
  "calendar.earlierYears": "Раније године",
  "calendar.endTime": "Крај",
  "calendar.evening": "Вече",
  "calendar.february": "Фебруар",
  "calendar.goToNextDay": "Следећи дан",
  "calendar.goToNextMonth": "Следећи месец",
  "calendar.goToNextWeek": "Следећа недеља",
  "calendar.goToNextYear": "Следећа година",
  "calendar.goToPreviousDay": "Претходни дан",
  "calendar.goToPreviousMonth": "Претходни месец",
  "calendar.goToPreviousWeek": "Претходна недеља",
  "calendar.goToPreviousYear": "Претходна година",
  "calendar.hour": "Сат",
  "calendar.hoursCount": "{count, plural, one {# сат} few {# сата} other {# сати}}",
  "calendar.hoursShort": "ч",
  "calendar.hoursShortCount": "{count, plural, one {# ч} few {# ч} other {# ч}}",
  "calendar.january": "Јануар",
  "calendar.july": "Јул",
  "calendar.june": "Јун",
  "calendar.last12Hours": "Последњих 12 сати",
  "calendar.last24Hours": "Последња 24 сата",
  "calendar.last30Days": "Последњих 30 дана",
  "calendar.last3Hours": "Последња 3 сата",
  "calendar.last6Hours": "Последњих 6 сати",
  "calendar.last7Days": "Последњих 7 дана",
  "calendar.lastHour": "Последњи сат",
  "calendar.laterYears": "Касније године",
  "calendar.march": "Март",
  "calendar.max": "Максимум",
  "calendar.may": "Мај",
  "calendar.month": "Месец",
  "calendar.monthTotal": "Овог месеца",
  "calendar.morning": "Јутро",
  "calendar.nextHours": "Следећи сати",
  "calendar.night": "Ноћ",
  "calendar.november": "Новембар",
  "calendar.october": "Октобар",
  "calendar.oneDay": "1 дан",
  "calendar.oneHour": "1 сат",
  "calendar.oneMonth": "1 месец",
  "calendar.oneWeek": "1 недеља",
  "calendar.periodRangeSpoken": "од {start} до {end}",
  "calendar.previous24Hours": "Претходна 24 сата",
  "calendar.previous30Days": "Претходних 30 дана",
  "calendar.previous7Days": "Претходних 7 дана",
  "calendar.previousDay": "Претходни дан",
  "calendar.previousHours": "Претходни сати",
  "calendar.previousMonth": "Претходни месец",
  "calendar.previousWeek": "Претходну недељу",
  "calendar.previousYear": "Претходну годину",
  "calendar.sameDayLastYear": "На исти дан претходне године",
  "calendar.sameMonthLastYear": "Током истог месеца претходне године",
  "calendar.selectADate": "Изаберите датум",
  "calendar.selectAggregation": "Изаберите приказану вредност",
  "calendar.selectAMonth": "Изаберите месец",
  "calendar.selectAYear": "Изаберите годину",
  "calendar.selectGranularity": "Изабери прецизност",
  "calendar.selectPeriod": "Изаберите период",
  "calendar.september": "Септембар",
  "calendar.sixHours": "6 сати",
  "calendar.startTime": "Почетак",
  "calendar.thirtyMinutes": "30 минута",
  "calendar.threeHours": "3 сата",
  "calendar.timezone": "Временска зона",
  "calendar.today": "Данас",
  "calendar.untilChanged": "Док се не промени",
  "calendar.untilTime": "До {time}",
  "calendar.untilTodayAt": "До данас у {time}",
  "calendar.untilTomorrowAt": "До сутра у {time}",
  "calendar.use24HourFormat": "Користи 24-часовни формат",
  "calendar.week": "Недеља",
  "calendar.year": "Година",
  "calendar.yearToDate": "Ове године",
  "calendar.yesterday": "Јучер",
  "charts.averageOverThePeriod": "Просек током периода",
  "charts.calendarView": "Календарски преглед",
  "charts.charts": "Дијаграми",
  "charts.chartView": "Преглед дијаграма",
  "charts.comparison": "Поређење",
  "charts.customizeComparisonMetrics": "Прилагодите метрике",
  "charts.customizeComparisonMetricsDescription": "Превлачите ставке да бисте поново организовали метрике поређења. Додирните икону ока да бисте приказали или скрили метрике.",
  "charts.loading": "Учитавање дијаграма",
  "charts.maxOverThePeriod": "Максимум током периода",
  "charts.measureToDisplay": "Мера за приказ",
  "charts.minMaxRange": "Мин. / Макс.",
  "charts.noDataForThisPeriod": "Нема података у периоду",
  "charts.observations": "Осматрања",
  "charts.observedTemperature": "Измерена температура",
  "charts.seriesTableDate": "Датум",
  "charts.showComparison": "Прикажи поређење",
  "charts.stationComparison": "Поређење станица",
  "charts.stationComparisonDescription": "Омогућава вам да упоредите историјске временске податке са подацима друге станице.",
  "charts.sumOverThePeriod": "Акумулирано током периода",
  "charts.tableLabel": "Табела: {chart}",
  "charts.toggleSeries": "Прикажи или сакриј {series}",
  "charts.viewAsChart": "Дијаграм",
  "charts.viewAsList": "Листа",
  "charts.viewAsPeriods": "Периоди",
  "charts.viewAsTable": "Табела",
  "charts.viewLabel": "Приказ: {chart}",
  "common.add": "Додај",
  "common.altitude": "Надморска висина",
  "common.analysis": "Анализа",
  "common.average": "Просек",
  "common.back": "Назад",
  "common.backToHome": "Назад на почетну",
  "common.cancel": "Откажи",
  "common.cannotBeEmpty": "Ово поље не може бити празно.",
  "common.close": "Затвори",
  "common.dailyForecast": "Дневна прогноза",
  "common.default": "Подразумевано",
  "common.delete": "Обриши",
  "common.details": "Детаљи",
  "common.edit": "Уреди",
  "common.exitFullscreen": "Изађи из целог екрана",
  "common.forecast": "Прогноза",
  "common.frequency": "Фреквенција",
  "common.full": "Пун",
  "common.fullscreen": "Цео екран",
  "common.help": "Помоћ",
  "common.hidden": "Скривено",
  "common.high": "Висок",
  "common.iDontKnowYet": "Још увек не знам",
  "common.indoor": "Унутра",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Последње ажурирање",
  "common.low": "Низак",
  "common.maximum": "Максимум",
  "common.medium": "Средњи",
  "common.minimum": "Минимум",
  "common.more": "Више",
  "common.moreInformation": "Више информација",
  "common.next": "Даље",
  "common.no": "Не",
  "common.noAccountNeeded": "Није потребан налог",
  "common.noItemsAvailable": "Нема доступних ставки",
  "common.notNow": "Не сада",
  "common.now": "Сада",
  "common.openSettings": "Отвори подешавања",
  "common.outdoor": "Вани",
  "common.pageNotFound": "Страница није пронађена",
  "common.pageNotFoundDescription": "Страница коју тражите не постоји или је премештена.",
  "common.rain": "Киша",
  "common.reorderCancel": "Премештање отказано: {item}. Поново на позицији {position} од {count}.",
  "common.reorderEnd": "Спуштено: {item}. Позиција {position} од {count}.",
  "common.reorderInstructions": "Да бисте преместили ову ставку, притисните размак или Enter, стрелицама горе и доле изаберите њено место, па поново притисните размак или Enter да је спустите, или Escape да откажете.",
  "common.reorderOver": "{item} – сада на позицији {position} од {count}.",
  "common.reorderStart": "Подигнуто: {item}. Позиција {position} од {count}.",
  "common.share": "Подели",
  "common.shareImageFailed": "Слика није могла да се подели",
  "common.shareYourWeather": "Поделите ваше временске услове",
  "common.skip": "Прескочи",
  "common.start": "Почети",
  "common.unknown": "Непознат",
  "common.validate": "Потврди",
  "common.validEmail": "Потребна је важећа адреса е-поште.",
  "common.very_low": "Веома низак",
  "common.weatherObservations": "Временска запажања",
  "common.welcome": "Добродошли у SmartMixin!",
  "common.wind": "Ветар",
  "common.yes": "Да",
  "common.zoomImage": "Увећај слику",
  "compass.E": "И",
  "compass.E_long": "Исток",
  "compass.ENE": "ИСИ",
  "compass.ENE_long": "Исток-североисток",
  "compass.ESE": "ИЈИ",
  "compass.ESE_long": "Исток-југоисток",
  "compass.N": "С",
  "compass.N_long": "Север",
  "compass.NE": "СИ",
  "compass.NE_long": "Североисток",
  "compass.NNE": "ССИ",
  "compass.NNE_long": "Север-североисток",
  "compass.NNW": "ССЗ",
  "compass.NNW_long": "Север-северозапад",
  "compass.NW": "СЗ",
  "compass.NW_long": "Северозапад",
  "compass.S": "Ј",
  "compass.S_long": "Југ",
  "compass.SE": "ЈИ",
  "compass.SE_long": "Југоисток",
  "compass.SSE": "ЈЈИ",
  "compass.SSE_long": "Југ-југоисток",
  "compass.SSW": "ЈЈЗ",
  "compass.SSW_long": "Југ-југозапад",
  "compass.SW": "ЈЗ",
  "compass.SW_long": "Југозапад",
  "compass.W": "З",
  "compass.W_long": "Запад",
  "compass.WNW": "ЗСЗ",
  "compass.WNW_long": "Запад-северозапад",
  "compass.WSW": "ЗЈЗ",
  "compass.WSW_long": "Запад-југозапад",
  "dashboard.currentObservations": "Тренутне вредности",
  "dashboard.currentRainEvent": "Тренутни догађај кише",
  "dashboard.currentWeatherConditions": "Тренутно време",
  "dashboard.customizeDashboard": "Прилагоди",
  "dashboard.customizeDashboardDescription": "Превуците ставке да промените редослед на контролној табли. Додирните икону ока да прикажете или сакријете секције.",
  "dashboard.dashboard": "Преглед",
  "dashboard.dayRangeExpected": "{value} се очекује у {time}",
  "dashboard.dayRangeReached": "{value} у {time}",
  "dashboard.dayRangeSteady": "Стабилно {value} цео дан",
  "dashboard.hiddenSensors": "Скривени сензори",
  "dashboard.hideSensor": "Сакриј {sensor}",
  "dashboard.lastRainEvent": "Последња киша",
  "dashboard.lastVisibleSensor": "Бар један сензор мора остати видљив.",
  "dashboard.manageSensors": "Управљање сензорима",
  "dashboard.manageSensorsDescription": "Превуците ставке да бисте променили редослед сензора. Додирните икону ока да бисте приказали или сакрили сензоре. Додирните назив да бисте га преименовали.",
  "dashboard.manageSensorsDescriptionWeb": "Кликните оловку да бисте преименовали сензор, превуците ручицу да бисте променили редослед листе и кликните око да бисте га сакрили или приказали.",
  "dashboard.moveSensor": "Помери {sensor}",
  "dashboard.pressureSummary": "Резиме притиска",
  "dashboard.rainEvents": "Кишни догађаји",
  "dashboard.rainSummary": "Резиме падавина",
  "dashboard.renameSensor": "Преименуј {sensor}",
  "dashboard.shareOutdoorMeasures": "Поделите ваша спољашња мерења",
  "dashboard.shareOutdoorMeasuresDescription": "Учествујте у заједници корисника апликације SmartMixin тако што ћете поделити мерења са вашег спољашњег модула. Мерења са унутрашњег модула никада неће бити дељена.",
  "dashboard.showSensor": "Прикажи {sensor}",
  "dashboard.temperatureSummary": "Резиме температуре",
  "dashboard.useDefaultSensorName": "Користи подразумевани назив",
  "dashboard.windSummary": "Резиме ветра",
  "devices.batteryLevel": "Ниво батерије",
  "devices.firmwareVersion": "Верзија фирмвера",
  "devices.moduleCount": "{count, plural, one {# модул} few {# модула} other {# модула}}",
  "devices.moduleType": "Тип модула",
  "devices.noNetatmoWeatherStationYet": "Још увек немате Netatmo метеостаницу.",
  "devices.noOutdoorModule": "Није откривен нити један спољашњи модул за ову станицу.",
  "devices.notReachable": "Недоступан",
  "devices.serialNumber": "Серијски број",
  "devices.signalAverage": "Умерен",
  "devices.signalBad": "Слаб",
  "devices.signalGood": "Добар",
  "devices.signalStrength": "Јачина сигнала",
  "devices.signalUnknown": "Непознат",
  "devices.visitNetatmoWebsite": "Посетите сајт Netatmo",
  "devices.wifiStrength": "Јачина сигнала Wi-Fi",
  "forecastMaps.addColor": "Додај боју",
  "forecastMaps.addLayer": "Додај слој",
  "forecastMaps.autoDescription": "Најбољи доступан за овај приказ",
  "forecastMaps.autoDescriptionFree": "Бесплатни налози користе {model}",
  "forecastMaps.autoPreview": "Ауто",
  "forecastMaps.autoSwitched": "Сада {model}: {previous} покрива {coverage, number, percent} овог приказа",
  "forecastMaps.backToMaps": "Назад на карте",
  "forecastMaps.build": "Генериши",
  "forecastMaps.buildCompleted": "Генерисање завршено",
  "forecastMaps.builderMetaDescription": "Саставите сопствене прогностичке карте од слојева метеоролошких модела.",
  "forecastMaps.builderTitle": "Израда карата",
  "forecastMaps.buildFailed": "Генерисање није успело. Покушајте поново.",
  "forecastMaps.buildNotPossible": "Ова карта се још не може генерисати — нема доступних прогностичких података.",
  "forecastMaps.buildProgress": "Исцртавање… {completed}/{total} корака",
  "forecastMaps.buildStarting": "Покретање генерисања…",
  "forecastMaps.byModel": "По моделу",
  "forecastMaps.byZone": "По зони",
  "forecastMaps.colormap": "Палета боја",
  "forecastMaps.colormapCustom": "Прилагођене боје",
  "forecastMaps.colormapGroupDomain": "Метеоролошки шаблони",
  "forecastMaps.colormapGroupMatplotlib": "Научни шаблони",
  "forecastMaps.colorStop": "Боја {position}",
  "forecastMaps.configUnavailable": "Ова прогностичка карта није доступна. Уместо ње приказује се {name}.",
  "forecastMaps.contourLevels": "Нивои изолинија",
  "forecastMaps.countryCanada": "Канада",
  "forecastMaps.countryFrance": "Француска",
  "forecastMaps.countryGermany": "Немачка",
  "forecastMaps.countryItaly": "Италија",
  "forecastMaps.countryScandinavia": "Скандинавија",
  "forecastMaps.countrySpain": "Шпанија",
  "forecastMaps.countrySwitzerland": "Швајцарска",
  "forecastMaps.countryUnitedStates": "Сједињене Државе",
  "forecastMaps.coverageUnknown": "Област непозната",
  "forecastMaps.coversView": "Покрива {coverage, number, percent} овог приказа",
  "forecastMaps.customColormapMinColors": "Прилагођена палета боја захтева најмање две боје",
  "forecastMaps.customExtent": "Прилагођени обухват",
  "forecastMaps.displayName": "Приказани назив",
  "forecastMaps.downscaling": "Фактор проређивања ветровних заставица",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Нацртај област",
  "forecastMaps.east": "Исток",
  "forecastMaps.extentDrawHint": "Превуците по карти да бисте нацртали област",
  "forecastMaps.extentInvalid": "Запад мора бити мањи од истока, а југ мањи од севера",
  "forecastMaps.frameTime": "Време прогнозе",
  "forecastMaps.height": "Висина (инчи)",
  "forecastMaps.hourOffset": "+{hour} ч",
  "forecastMaps.inThisArea": "У овој области",
  "forecastMaps.invalidHexColor": "Неважећа боја — користите #RRGGBB",
  "forecastMaps.layerHasErrors": "Овај слој садржи грешке",
  "forecastMaps.layers": "Слојеви",
  "forecastMaps.layerTypeBarbs": "Ветровне заставице",
  "forecastMaps.layerTypeContour": "Изолиније",
  "forecastMaps.layerTypeFilledContour": "Испуњене изолиније",
  "forecastMaps.layerTypeMagnitude": "Магнитуда",
  "forecastMaps.layerTypeRaster": "Растер",
  "forecastMaps.layerTypeVectorField": "Векторско поље",
  "forecastMaps.leave": "Изађи",
  "forecastMaps.levelsCount": "Број",
  "forecastMaps.levelsInvalid": "Неважећи нивои изолинија",
  "forecastMaps.levelsModeArange": "Фиксни корак",
  "forecastMaps.levelsModeExplicit": "Експлицитне вредности",
  "forecastMaps.levelsModeLinspace": "Равномерно распоређено (број)",
  "forecastMaps.levelsStep": "Корак",
  "forecastMaps.levelsValues": "Вредности",
  "forecastMaps.levelsValuesHint": "Одвојене зарезима, растуће",
  "forecastMaps.loadingMaps": "Учитавање мапа…",
  "forecastMaps.localTimeHint": "Приказано по вашем локалном времену",
  "forecastMaps.lockedConfig": "{model} је Premium модел. Уместо њега приказује се {fallback}.",
  "forecastMaps.lockedVariable": "{variable}, Premium",
  "forecastMaps.mapDescription": "Опис",
  "forecastMaps.mapName": "Назив карте",
  "forecastMaps.mapNameRequired": "Унесите назив",
  "forecastMaps.mapSettings": "Подешавања карте",
  "forecastMaps.maxLayersReached": "Ова карта је достигла максимум од {max} слојева.",
  "forecastMaps.maxValue": "Максимална вредност",
  "forecastMaps.memoryBudgetExceeded": "Резолуција премашује буџет исцртавања — смањите DPI или висину",
  "forecastMaps.memoryBudgetUsage": "Буџет исцртавања: {percent}%",
  "forecastMaps.metaDescription": "Анимиране прогностичке карте израђене из прорачуна метеоролошких модела.",
  "forecastMaps.metric": "Величина",
  "forecastMaps.metricRequired": "Изаберите величину",
  "forecastMaps.metricUnavailable": "Није доступно за овај модел",
  "forecastMaps.minBelowMax": "Минимум мора бити мањи од максимума",
  "forecastMaps.minMaxRequired": "Минимална и максимална вредност су обавезне за ову врсту слоја",
  "forecastMaps.minValue": "Минимална вредност",
  "forecastMaps.modelChipAuto": "Ауто · {model}",
  "forecastMaps.modelCoversView": "{model} покрива {coverage, number, percent} овог приказа",
  "forecastMaps.modelNoRun": "Још нема завршеног прорачуна",
  "forecastMaps.modelOption": "{model}, {grid}",
  "forecastMaps.moveLayerDown": "Помери надоле",
  "forecastMaps.moveLayerUp": "Помери нагоре",
  "forecastMaps.nanClipToMin": "Ограничи на минимум",
  "forecastMaps.nanMask": "Маскирај",
  "forecastMaps.nanPolicy": "Недостајући подаци",
  "forecastMaps.nanSkip": "Прескочи",
  "forecastMaps.noCompletedRun": "Ова карта још није израђена. Проверите поново ускоро.",
  "forecastMaps.noLayers": "Још нема слојева. Додајте слој за почетак.",
  "forecastMaps.noMapsAvailable": "Прогностичке карте још нису доступне.",
  "forecastMaps.north": "Север",
  "forecastMaps.opacity": "Непрозирност",
  "forecastMaps.openAsAnimation": "Отвори као анимацију",
  "forecastMaps.otherAreas": "Друге области",
  "forecastMaps.outsideArea": "Не покрива ову област",
  "forecastMaps.overlayLegend": "Легенда",
  "forecastMaps.pause": "Пауза",
  "forecastMaps.play": "Репродукуј",
  "forecastMaps.pointValueAnnouncement": "{value}, {time}",
  "forecastMaps.pointValueError": "Прогноза за ову тачку није могла да се учита.",
  "forecastMaps.pointValueLoading": "Учитавање прогнозе…",
  "forecastMaps.pointValueUnavailable": "Нема података за ово време.",
  "forecastMaps.premiumModelForView": "{model} покрива овај приказ",
  "forecastMaps.premiumRequired": "Прогностичке карте захтевају Premium",
  "forecastMaps.preview": "Преглед",
  "forecastMaps.previewEmptyHint": "Подесите бар један исправан слој за исцртавање прегледа.",
  "forecastMaps.previewFailed": "Преглед није успео",
  "forecastMaps.previewHour": "Сат прогнозе",
  "forecastMaps.previewRendering": "Исцртавање прегледа…",
  "forecastMaps.projection": "Пројекција",
  "forecastMaps.projectionLambertConformal": "Ламбертова конформна",
  "forecastMaps.projectionMercator": "Меркаторова",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Стереографска",
  "forecastMaps.regionEurope": "Европа",
  "forecastMaps.regionNorthAmerica": "Северна Америка",
  "forecastMaps.removeColor": "Уклони боју",
  "forecastMaps.removeLayer": "Уклони слој",
  "forecastMaps.retry": "Покушај поново",
  "forecastMaps.run": "Прорачун: {run}",
  "forecastMaps.runNotDisplayable": "Овај прорачун не може да се прикаже на интерактивној карти.",
  "forecastMaps.save": "Сачувај",
  "forecastMaps.selectExtentOnMap": "Изабери област на карти",
  "forecastMaps.showArea": "Прикажи област",
  "forecastMaps.showAreaOf": "Прикажи област, {model}",
  "forecastMaps.south": "Југ",
  "forecastMaps.switchToModel": "Пребаци на {model}",
  "forecastMaps.title": "Прогностичке карте",
  "forecastMaps.uMetric": "U-компонента",
  "forecastMaps.unitConversion": "Претварање јединица",
  "forecastMaps.unitNone": "Без претварања",
  "forecastMaps.unsavedChangesBody": "Имате несачуване измене. Изаћи и одбацити их?",
  "forecastMaps.unsavedChangesTitle": "Несачуване измене",
  "forecastMaps.useCurrentView": "Користи тренутни приказ",
  "forecastMaps.useModelDomain": "Искључено: користи се цела област модела",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Величине U и V морају се разликовати",
  "forecastMaps.valueAtMapCentre": "Вредност у средишту карте",
  "forecastMaps.valueBetween": "Мора бити између {min} и {max}",
  "forecastMaps.variable": "Променљива",
  "forecastMaps.variableMissing": "{variable}: нема података",
  "forecastMaps.variableOnlyFrom": "{variable}: само из модела {model}",
  "forecastMaps.viewMap": "Прикажи карту",
  "forecastMaps.vMetric": "V-компонента",
  "forecastMaps.west": "Запад",
  "forecastMaps.windAnimation": "Анимација ветра",
  "forecastModels.addForecastModel": "Додај модел",
  "forecastModels.atYourStations": "Доступни на вашим станицама",
  "forecastModels.comparisonLoadError": "Учитавање поређења временских модела није успело",
  "forecastModels.coverageLoading": "Утврђујемо које ваше станице покрива сваки модел…",
  "forecastModels.description_AROME": "Високорезолуциони модел Météo Francea који омогућава разлучивање конвекције над западном Европом са резолуцијом од 1,3 км. Најбољи у класи за краткорочне прогнозе у Француској; ажурира се сваких три сата.",
  "forecastModels.description_ARPEGE_EU": "Европски угњеждени домен модела ARPEGE Météo Francea са резолуцијом од 10 км. Средњорочне прогнозе над Европом, ажурирају се четири пута дневно.",
  "forecastModels.description_ARPEGE_GLOBAL": "Глобални нумерички модел времена Météo Francea са резолуцијом од 25 км, до отприлике 4 дана. Ажурира се четири пута дневно.",
  "forecastModels.description_DMI_DINI": "HARMONIE DINI од DMI: модел који омогућава разлучивање конвекције над северозападном Европом — Данска, Бенелукс, Ирска, Уједињено Краљевство и Скандинавија — са резолуцијом од 2 км који иде до 60 сати, ажурира се осам пута дневно. Садржи измењене отворене податке DMI-ја (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Global Deterministic Prediction System (глобални детерминистички систем предвиђања) агенције Environment Canada: светски средњорочни модел са резолуцијом од 15 км који иде до 10 дана, ажурира се два пута дневно.",
  "forecastModels.description_EC_HRDPS": "High Resolution Deterministic Prediction System (детерминистички систем предвиђања високе резолуције) агенције Environment Canada: модел који омогућава разлучивање конвекције над Канадом и северним делом Сједињених Држава са резолуцијом од 2,5 км који иде до 48 сати, ажурира се четири пута дневно.",
  "forecastModels.description_EC_RDPS": "Regional Deterministic Prediction System (регионални детерминистички систем предвиђања) агенције Environment Canada: средњорочни модел над Северном Америком са резолуцијом од 10 км, ажурира се четири пута дневно.",
  "forecastModels.description_ECMWF_HRES": "Водећи модел високе резолуције (IFS) Европског центра за средњорочне временске прогнозе, широко сматран најбољим глобалним прогностичким системом на свету. Покрива целу планету резолуцијом од 25 км до 15 дана, ажурира се четири пута дневно. Садржи измењене отворене податке ECMWF-а (CC BY 4.0).",
  "forecastModels.description_GFS": "Водећи средњорочни глобални модел NOAA. Покрива целу планету са резолуцијом од 25 км до 16 дана, ажурира се четири пута дневно.",
  "forecastModels.description_HRRR_CONUS": "High-Resolution Rapid Refresh од NOAA: модел који омогућава разлучивање конвекције над континенталним САД са резолуцијом од 3 км, ажурира се сваког сата. Најпогоднији за веома краткорочне прогнозе грмљавинских олуја и јаког времена.",
  "forecastModels.description_ICON": "Глобални модел ICON DWD-а резолуције 13 км који покрива целу планету до 7,5 дана, ажурира се четири пута дневно. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ICON-2I агенције ItaliaMeteo, који се изводи заједно са ARPAE: модел који омогућава разлучивање конвекције над Италијом са резолуцијом од 2,2 км који иде до 72 сата, ажурира се двапут дневно. Садржи отворене податке ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "Контролно извођење модела ICON-CH1-EPS агенције MeteoSwiss: модел који омогућава разлучивање конвекције над Алпима са резолуцијом од 1 км који иде до 33 сата, ажурира се свака три сата.",
  "forecastModels.description_ICON_CH2": "Контролно извођење модела ICON-CH2-EPS агенције MeteoSwiss: модел који омогућава разлучивање конвекције над Алпима — Швајцарска и околни алпски регион — са резолуцијом од 2,1 км који иде до 120 сати, ажурира се четири пута дневно.",
  "forecastModels.description_ICON_DE": "Високорезолуциони модел DWD-а који омогућава разлучивање конвекције над Немачком и суседним земљама са резолуцијом од 2,2 км. Краткорочне прогнозе ажурирају се два пута дневно. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "Европски угњеждени домен модела ICON DWD-а са резолуцијом од 7 км који покрива Европу и Северни Атлантик. Средњорочне прогнозе ажурирају се четири пута дневно. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "Отворена услуга прогнозе времена Норвешког метеоролошког института, која комбинује високорезолуционе нордијске моделе са подацима ECMWF да би пружила глобалне прогнозе до 10 дана унапред.",
  "forecastModels.description_MF_AROME_ANTILLES": "Угњеждени AROME домен над француским Антилима (Гваделупа, Мартиник) са резолуцијом од 2,5 км. Краткорочне прогнозе ажурирају се четири пута дневно.",
  "forecastModels.description_MF_AROME_GUYANE": "Угњеждени AROME домен над Француском Гвајаном са резолуцијом од 2,5 км. Краткорочне прогнозе ажурирају се четири пута дневно.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Угњеждени AROME домен над Новом Каледонијом са резолуцијом од 2,5 км. Краткорочне прогнозе ажурирају се четири пута дневно.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Угњеждени AROME домен над Француском Полинезијом са резолуцијом од 2,5 км. Краткорочне прогнозе ажурирају се четири пута дневно.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Угњеждени AROME домен над Реинионом и Мајотом са резолуцијом од 2,5 км. Краткорочне прогнозе ажурирају се четири пута дневно.",
  "forecastModels.description_RRFS_CONUS": "NOAA-ин систем Rapid Refresh Forecast над континенталним САД резолуције 3 km. Сатне прогнозе освежавају се осам пута дневно, до 84 сата у четири главна пролаза и 18 сати у осталима.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "NOAA-ин систем Rapid Refresh Forecast који покрива целу Северну Америку резолуције 13 km. Сатне прогнозе до 84 сата, освежавају се четири пута дневно.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "Водећа прогноза SmartMixin-а. За сваки сат на вашој локацији бирамо најбољи доступни модел — обично високорезолуциони регионални модел тамо где постоји (AROME у Француској, ICON-D2 у Немачкој, HRRR у САД, ARPEGE Europe широм континента…) и враћамо се на глобални модел другде — затим попуњавамо све празнине из суседних извора. Резултат је јединствена беспрекорна прогноза која покрива било где у свету до 14 дана, аутоматски се ажурира сваки пут када се неки од основних модела ажурира.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Власничка глобална прогноза Weatherflow која меша више нумеричких модела времена са посматрањима из своје мреже Tempest метеоролошких станица. Глобални хоризонт од 10 дана.",
  "forecastModels.everywhereElse": "Свуда другде",
  "forecastModels.everywhereElseFoot": "Користи се на свакој станици до које ваши жељени модели не досежу.",
  "forecastModels.everywhereElsePick": "Изаберите један",
  "forecastModels.fallbackBlend": "SmartMixin мешавина",
  "forecastModels.fallbackBlendSub": "Комбинује више модела, сваки тамо где је најјачи.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES свуда где досеже.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "NOAA-ин глобални модел. Оно што данас користи сваки налог.",
  "forecastModels.fallbackResolution": "Највиша резолуција",
  "forecastModels.fallbackResolutionSub": "Најфинија мрежа доступна на свакој станици.",
  "forecastModels.forecastChipLabelWithRun": "{model}, прорачун {run}",
  "forecastModels.forecastChipRunHint": "Дуго притисните да прикажете или сакријете најновији прорачун",
  "forecastModels.forecastComparisonDescription": "Лако упоредите податке из различитих доступних временских модела",
  "forecastModels.forecastFollowingPreferences": "Према вашим подешавањима",
  "forecastModels.forecastLoadError": "Учитавање прогнозе није успело",
  "forecastModels.forecastModel": "Прогностички модел",
  "forecastModels.forecastModelAbout": "О моделу {model}",
  "forecastModels.forecastModelComparison": "Поређење временских модела",
  "forecastModels.forecastModelCoverage": "Покривеност",
  "forecastModels.forecastModelDescription": "Опис",
  "forecastModels.forecastModels": "Модели прогнозе",
  "forecastModels.forecastModelScopeGlobal": "Глобални",
  "forecastModels.forecastModelScopeGlobalDescription": "Овај модел покрива целу планету.",
  "forecastModels.forecastModelScopeRegional": "Регионални",
  "forecastModels.forecastModelScopeRegionalDescription": "Овај модел покрива само одређени регион.",
  "forecastModels.forecastModelSpecifications": "Спецификације",
  "forecastModels.forecastNoPinLocation": "Ниједан жељени модел не досеже ову локацију — одлучује „свуда другде”.",
  "forecastModels.forecastNoPinStation": "Ниједан жељени модел не досеже ову станицу — одлучује „свуда другде”.",
  "forecastModels.forecastNoPreferredModels": "Још нема постављених жељених модела.",
  "forecastModels.forecastOverrideElsewhere": "Ваша подешавања важе свуда другде.",
  "forecastModels.forecastPickForLocation": "Или изаберите један за ову локацију",
  "forecastModels.forecastPickForStation": "Или изаберите један за ову станицу",
  "forecastModels.forecastPinWinsLocation": "{model} — ваш први жељени модел који досеже ову локацију.",
  "forecastModels.forecastPinWinsStation": "{model} — ваш први жељени модел који досеже ову станицу.",
  "forecastModels.forecastServedNowHere": "Тренутно је овде {model}",
  "forecastModels.forecastSetForLocation": "Постављено за ову локацију",
  "forecastModels.forecastSetForStation": "Постављено за ову станицу",
  "forecastModels.forecastSettingsRowSub": "Жељени модели и шта важи свуда другде",
  "forecastModels.forecastStopUsingHere": "Престани да користиш овде",
  "forecastModels.forecastUseForLocation": "Користи {model} за ову локацију",
  "forecastModels.forecastUseForStation": "Користи {model} за ову станицу",
  "forecastModels.forecastUsePreferred": "Користи моје жељене моделе",
  "forecastModels.frequencyHourly": "Сваког сата",
  "forecastModels.horizon": "Хоризонт",
  "forecastModels.horizonValue": "до {value} сати",
  "forecastModels.meshSize": "Величина мреже",
  "forecastModels.pickerShowAll": "Прикажи цео каталог",
  "forecastModels.pickerUnreachable": "{count, plural, one {# додатни модел не досеже} few {# додатна модела не досежу} other {# додатних модела не досеже}} ниједну вашу станицу",
  "forecastModels.pinInUse": "У употреби",
  "forecastModels.pinShadowed": "Никада се не користи — модел изнад покрива све ваше станице",
  "forecastModels.pinSlots": "{used} од {max} · изаберите модел",
  "forecastModels.pinSlotsFull": "{max, plural, =1 {Једино место је заузето. Уклоните његов модел да бисте додали други.} one {Сва места (#) су заузета. Уклоните једно да бисте додали друго.} few {Сва # места су заузета. Уклоните једно да бисте додали друго.} other {Свих # места је заузето. Уклоните једно да бисте додали друго.}}",
  "forecastModels.pinsUncoveredCount": "{used} од ваших {count, plural, one {# станице} few {# станице} other {# станица}}: ниједан жељени модел не досеже до {used, plural, =1 {ње} other {њих}} — одлучује „свуда другде”.",
  "forecastModels.pinsUncoveredNamed": "{stations}: ниједан жељени модел не досеже до {count, plural, one {ње} other {њих}} — одлучује „свуда другде”.",
  "forecastModels.pinUnreachable": "Никада се не користи — не досеже ниједну вашу станицу",
  "forecastModels.pinUsedAt": "Користи се на {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, =1 {Користи се на вашој станици} other {Користи се на свим станицама (#)}}",
  "forecastModels.pinUsedAtSome": "Користи се на {used} од {count, plural, one {# станице} few {# станице} other {# станица}}",
  "forecastModels.preferredModels": "Жељени модели",
  "forecastModels.preferredModelsAll": "Једна листа, све станице",
  "forecastModels.preferredModelsOne": "Једна листа, важи свуда",
  "forecastModels.publisher": "Издавач",
  "forecastModels.removePreferredModel": "Уклони {model} из жељених модела",
  "forecastModels.resetForecastPreference": "Врати подразумевано",
  "forecastModels.resetForecastPreferenceHint": "Брише ваше жељене моделе и враћа подразумевано подешавање SmartMixin-а.",
  "forecastModels.servedNowMany": "Управо сада: GFS {count, plural, =1 {на вашој станици} other {на свим вашим станицама (#)}}.",
  "forecastModels.servedNowNone": "Управо сада: GFS свуда.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin мултимодел",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Weatherflow прогноза",
  "forecastModels.weatherForecastModels": "Модели временске прогнозе",
  "helpCenter.articleCount": "{count, plural, one {# чланак} few {# чланка} other {# чланака}}",
  "helpCenter.articleNotFound": "Чланак није пронађен",
  "helpCenter.articleNotFoundDescription": "Чланак који тражите не постоји.",
  "helpCenter.backToHelpCenter": "Назад у центар за помоћ",
  "helpCenter.browseByCategory": "Прегледај по категорији",
  "helpCenter.categoryNotFound": "Категорија није пронађена",
  "helpCenter.categoryNotFoundDescription": "Ова категорија не постоји или нема чланака.",
  "helpCenter.contactSupport": "Контактирајте подршку",
  "helpCenter.feedbackHelpsImprove": "Ваше повратне информације помажу нам да побољшамо чланке помоћи.",
  "helpCenter.feedbackReasonNotAnswer": "Не одговара на моје питање",
  "helpCenter.feedbackReasonOutdated": "Информације су застареле",
  "helpCenter.feedbackReasonUnclear": "Упутства су нејасна",
  "helpCenter.feedbackWhatWentWrong": "У чему је био проблем?",
  "helpCenter.helpCategoryAccount": "Налог",
  "helpCenter.helpCategoryBilling": "Наплата",
  "helpCenter.helpCategoryForecast": "Прогнозе",
  "helpCenter.helpCategoryGettingStarted": "Први кораци",
  "helpCenter.helpCategoryProviders": "Провајдери",
  "helpCenter.helpCategoryStations": "Станице",
  "helpCenter.helpCategoryTroubleshooting": "Решавање проблема",
  "helpCenter.helpCenter": "Центар за помоћ",
  "helpCenter.landingDescription": "Пронађите одговоре на честа питања и сазнајте како да максимално искористите SmartMixin.",
  "helpCenter.linkToSection": "Веза ка овом одељку",
  "helpCenter.menuItemDescription": "Често постављана питања и водичи",
  "helpCenter.minRead": "{minutes} мин читања",
  "helpCenter.onThisPage": "На овој страници",
  "helpCenter.platformMobileApp": "Мобилна апликација",
  "helpCenter.platformMobileOnly": "Само у мобилној апликацији",
  "helpCenter.platformWebApp": "Веб апликација",
  "helpCenter.platformWebOnly": "Само у веб апликацији",
  "helpCenter.popularArticles": "Популарни чланци",
  "helpCenter.relatedArticles": "Повезани чланци",
  "helpCenter.searchArticles": "Претражи чланке...",
  "helpCenter.stillNeedHelp": "И даље вам је потребна помоћ?",
  "helpCenter.stillNeedHelpDescription": "Ако овај чланак није одговорио на ваше питање, радо ћу вам помоћи директно.",
  "helpCenter.supportEmailSubject": "SmartMixin помоћ",
  "helpCenter.supportEmailSubjectTopic": "SmartMixin помоћ — {topic}",
  "helpCenter.thankYouForFeedback": "Хвала на повратним информацијама!",
  "helpCenter.wasArticleHelpful": "Да ли вам је овај чланак био користан?",
  "intro.locationDescription": "Омогућите приступ локацији за прецизне временске прогнозе прилагођене вашем тачном подручју — без универзалних прогноза.",
  "intro.locationTitle": "Прогнозе направљене за вас",
  "intro.notificationDescription": "Укључите обавештења за правовремена упозорења о временским променама које су вам важне — киша, снег или тешки услови, баш када треба.",
  "intro.notificationsTitle": "Никада не пропустите промену времена",
  "intro.readyDescription": "Уживајте у прецизним прогнозама, временским увидима у реалном времену и подацима са станица широм света — све у једној моћној апликацији.",
  "intro.readyTitle": "Спремни сте!",
  "intro.welcomeDescription": "Добијте хиперлокалне прогнозе од најбољих метеоролошких агенција — плус приступ преко 40.000 метеоролошких станица широм света за реалне услове, прошле и садашње.",
  "intro.welcomeTitle": "Ваша временска прогноза, осмишљена изнова",
  "landing.alsoAvailableOn": "Доступно и на:",
  "landing.featureAlertsDescription": "Поставите прилагођене прагове за било коју мерну величину. Примајте обавештења када температура падне, почне киша или ветар ојача.",
  "landing.featureAlertsTitle": "Паметна упозорења",
  "landing.featureAnalyticsDescription": "Интерактивни графикони, анализа трендова и детаљна статистика. Уроните у податке о температури, влажности, притиску, киши и ветру.",
  "landing.featureAnalyticsTitle": "Напредна аналитика",
  "landing.featureExportDescription": "Примите све своје временске податке имејлом као Excel табелу, спремну за даљу анализу у Excel-у, Google табелама или омиљеним алатима.",
  "landing.featureExportTitle": "Извезите своје податке",
  "landing.featureForecastDescription": "Приступите {count, plural, one {#+ професионалном прогностичком моделу} few {#+ професионална прогностичка модела} other {#+ професионалних прогностичких модела}}, укључујући ECMWF, GFS и регионалне моделе. Упоредите их један поред другог и направите сопствене прогнозе.",
  "landing.featureForecastTitle": "Упоредите прогностичке моделе",
  "landing.featureHistoryDescription": "Приступ историјским подацима са сатном, дневном и месечном скалом. Извезите их у Excel за истраживање или личне архиве.",
  "landing.featureHistoryTitle": "Богата историја",
  "landing.featureMultiBrandDescription": "Повежите Netatmo, Davis, Tempest, Ecowitt, Ambient Weather и друге. Нема више пребацивања између апликација.",
  "landing.featureMultiBrandTitle": "Све марке, једна апликација",
  "landing.featuresSubtitle": "SmartMixin вам даје алате да анализирате, упоређујете и разумете своје временске податке као професионалац.",
  "landing.featuresTitle": "Направљено за љубитеље података",
  "landing.finalCtaButton": "Направите бесплатан налог",
  "landing.finalCtaSubtitle": "Придружите се хиљадама љубитеља времена који верују SmartMixin-у.",
  "landing.finalCtaTitle": "Спремни да дубље уроните у своје временске податке?",
  "landing.heroCta": "Почните бесплатно",
  "landing.heroDescription": "Детаљна аналитика, лепи графикони и професионалне прогнозе — све ваше метеоролошке станице обједињене у једној моћној апликацији.",
  "landing.heroSecondaryCta": "Истражите карту",
  "landing.heroTagline": "За љубитеље времена",
  "landing.heroTitle": "Погледајте време као никада раније",
  "landing.pricingComparisonCaption": "Поређење функција бесплатног плана и плана Premium",
  "landing.pricingFeatureAdvancedMetrics": "Напредне метрике",
  "landing.pricingFeatureAlerts": "Прилагођена упозорења",
  "landing.pricingFeatureColumn": "Функција",
  "landing.pricingFeatureExport": "Извоз података (Excel)",
  "landing.pricingFeatureForecastComparison": "Поређење прогноза",
  "landing.pricingFeatureForecasts": "Модели прогнозе",
  "landing.pricingFeatureForecastsFreeTier": "1 модел",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ модел} few {#+ модела} other {#+ модела}}",
  "landing.pricingFeatureReports": "Анализе и извештаји",
  "landing.pricingFeatureStationComparison": "Поређење станица",
  "landing.pricingFeatureWidgets": "Виџети почетног екрана",
  "landing.pricingFeatureYearOverYear": "Анализа година за годином",
  "landing.pricingFreeCta": "Започните",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Најпопуларније",
  "landing.pricingPremiumCta": "Започните",
  "landing.pricingPremiumDescription": "Од 1,99 €/месец — претплатите се на вебу, App Store-у или Google Play-у",
  "landing.pricingSubtitle": "Почните бесплатно, надоградите када вам треба више.",
  "landing.pricingTitle": "Једноставне, транспарентне цене",
  "landing.statBrands": "Подржаних марки",
  "landing.statForecasts": "Модела прогнозе",
  "landing.statStations": "Метеоролошких станица",
  "landing.supportedDevicesNote": "Плус више од {count, number} јавних станица из мреже Светске метеоролошке организације",
  "landing.supportedDevicesSubtitle": "Повежите своју постојећу метеоролошку станицу за неколико минута. Подржавамо {count, plural, one {# велику марку} few {# велике марке} other {# великих марки}}, а њихов број расте.",
  "landing.supportedDevicesTitle": "Ради са вашом станицом",
  "metrics.absolutePressure": "Апсолутни притисак",
  "metrics.airDensity": "Густина ваздуха",
  "metrics.airGap": "Ваздушни размак",
  "metrics.apparentTemperature": "Привидна температура",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Просек",
  "metrics.avg_wind": "Просечан ветар",
  "metrics.beaufort": "Beaufort",
  "metrics.blackGlobeTemperature": "Темп. црне кугле",
  "metrics.boilerOn": "Бојлер УКЉУЧЕН",
  "metrics.boilerOnInHours": "Бојлер УКЉУЧЕН (сати)",
  "metrics.cloudCover": "Облачност",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Проводљивост",
  "metrics.dailyPrecipitation": "Дневне падавине",
  "metrics.dailyRain": "Дневна киша",
  "metrics.degreeDayShort": "ДС",
  "metrics.depth": "Дубина",
  "metrics.depthSensors": "Сензори дубине",
  "metrics.dewPoint": "Тачка рошења",
  "metrics.distance": "Удаљеност",
  "metrics.downTrend": "Силазни тренд",
  "metrics.ET": "Евапотранспирација",
  "metrics.etToday": "Евапотранспирација данас",
  "metrics.feelsLike": "Субјективни осећај",
  "metrics.feelsLikeWithFormula": "Субјективни осећај ({formula})",
  "metrics.frostPoint": "Тачка мраза",
  "metrics.gust": "Удар ветра",
  "metrics.gustDirection": "Смер удара ветра",
  "metrics.hail": "Град",
  "metrics.heatIndex": "Индекс топлоте",
  "metrics.heatingDegreeDays": "Дневни степени загревања",
  "metrics.heatingPower": "Снага загревања",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Влажност",
  "metrics.lastLightningImpact": "Последњи удар",
  "metrics.lastMeasure": "Последње мерење",
  "metrics.leafSensors": "Сензори лишћа",
  "metrics.leafWetness": "Влажност листова",
  "metrics.lightningDistance": "Удаљеност",
  "metrics.lightningStrikeCount": "Бројач удара муње",
  "metrics.lightningStrikeDistance": "Удаљеност од места удара муње",
  "metrics.max": "Макс.",
  "metrics.max_gust": "Макс. удар ветра",
  "metrics.maxToday": "Макс. данас",
  "metrics.min": "Мин.",
  "metrics.noise": "Бука",
  "metrics.normalizedHeatingCoefficient": "Нормализовани коефицијент загревања",
  "metrics.outdoorTemperature": "Спољна температура",
  "metrics.PM_1": "PM1",
  "metrics.PM_10": "PM10",
  "metrics.PM_2P5": "PM2.5",
  "metrics.precipitation": "Падавине",
  "metrics.pressure": "Притисак",
  "metrics.rain": "Киша",
  "metrics.rainDurationValue": "Трајање кише: {duration}",
  "metrics.rainfallMeasurement": "Мерење количине падавина",
  "metrics.rainRate": "Интензитет кише",
  "metrics.relativePressure": "Релативни притисак",
  "metrics.setPoint": "Задата температура",
  "metrics.snow": "Снег",
  "metrics.snowfall": "Снегопад",
  "metrics.soilMoisture": "Влажност земљишта",
  "metrics.soilSensors": "Сензори земљишта",
  "metrics.soilWaterTension": "Тензија воде у земљишту",
  "metrics.solarEnergy": "Соларна енергија",
  "metrics.solarRadiation": "Осунчаност",
  "metrics.speed": "Брзина",
  "metrics.stableTrend": "Стабилан тренд",
  "metrics.sum": "Збир",
  "metrics.temperature": "Температура",
  "metrics.temperatureSensors": "Сензори температуре/влажности",
  "metrics.temperatureShort": "Темп.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "Узлазни тренд",
  "metrics.uv": "UV",
  "metrics.visibility": "Видљивост",
  "metrics.weatherCondition": "Услови времена",
  "metrics.wetBulbGlobeTemperature": "Темп. влажне кугле",
  "metrics.wetBulbTemperature": "Темп. влажног термометра",
  "metrics.wind": "Ветар",
  "metrics.windChill": "Осећај хладноће",
  "metrics.windDirection": "Смер ветра",
  "metrics.windMeasurement": "Мерења ветра",
  "metrics.windRun": "Пут ветра",
  "metrics.windRunDescription": "Пут ветра је укупна удаљеност коју ветар пређе у одређеном временском периоду",
  "metrics.windSpeed": "Брзина ветра",
  "navigation.allFavorites": "Прикажи све",
  "navigation.breadcrumbs": "Навигациона путања",
  "navigation.collapseNavigation": "Скупи навигацију",
  "navigation.expandNavigation": "Прошири навигацију",
  "navigation.main": "Главна",
  "navigation.mapShort": "Карта",
  "navigation.skipToContent": "Пређи на главни садржај",
  "navigation.stationsShort": "Станице",
  "network.cancelError": "Захтев је отказан",
  "network.connectionError": "Сервер је недоступан",
  "network.networkError": "Мрежа није доступна",
  "network.serverError": "Нешто је погрешно...",
  "network.timeoutError": "Повезивање је истекло",
  "network.unknownError": "Непозната грешка",
  "premium.alreadyPremium": "Већ имате премијум налог!",
  "premium.bestValue": "Најбоља понуда",
  "premium.billingDetailsAndroid": "Бесплатни пробни период: ништа вам неће бити наплаћено ако откажете најмање 24 часа пре краја пробног периода. Након тога се ваша претплата на SmartMixin аутоматски обнавља, осим ако је не откажете најмање 24 часа пре краја текућег периода; можете је отказати у било ком тренутку у подешавањима свог Google Play налога. Свака обнова се наплаћује по цени приказаној на дугмету изнад. Плаћање се наплаћује са вашег Google Play налога када потврдите куповину и на почетку сваког периода обнове.",
  "premium.billingDetailsIos": "Бесплатни пробни период: ништа вам неће бити наплаћено ако откажете најмање 24 часа пре краја пробног периода. Након тога се ваша претплата на SmartMixin аутоматски обнавља, осим ако је не откажете најмање 24 часа пре краја текућег периода; можете је отказати у било ком тренутку у подешавањима свог App Store налога. Свака обнова се наплаћује по цени приказаној на дугмету изнад. Плаћање се наплаћује са вашег App Store налога када потврдите куповину и на почетку сваког периода обнове.",
  "premium.freeBannerBody": "Бесплатни налози свуда добијају GFS — ваши жељени модели и „свуда другде” почињу да раде чим се претплатите.",
  "premium.freeBannerTitle": "Подешавања важе уз Premium",
  "premium.freeSubscription": "Бесплатна претплата",
  "premium.freeTrialForPeriod": "Бесплатни пробни период од {period, plural, one {# дана} few {# дана} other {# дана}}",
  "premium.getUnlimitedAccess": "Неограничен приступ:",
  "premium.manageMySubscription": "Управљај претплатом",
  "premium.notPurchasedYet": "За овај налог продавнице није пронађена ниједна куповина SmartMixin Premium.",
  "premium.orChooseMonthly": "Или одаберите месечно:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Активно",
  "premium.premiumAnnualTrialInfo": "Започните са бесплатним пробним периодом од {days, plural, one {# дана} few {# дана} other {# дана}}",
  "premium.premiumCurrentPlan": "Тренутни план",
  "premium.premiumDownloadApp": "Преузмите апликацију да бисте се претплатили:",
  "premium.premiumEndsOn": "Истиче {date}",
  "premium.premiumFeatureAlerts": "Временска упозорења",
  "premium.premiumFeatureAnalysis": "Напредна анализа времена",
  "premium.premiumFeatureCharts": "Упоређивање графикона",
  "premium.premiumFeatureExport": "Извоз података",
  "premium.premiumFeatureForecast": "Регионални прогностички модели",
  "premium.premiumFeatureNotification": "Виџет статусне траке",
  "premium.premiumFeatureTitle": "Premium функција",
  "premium.premiumFeatureWidgets": "Виџети почетног екрана",
  "premium.premiumFreePlan": "Бесплатно",
  "premium.premiumInactive": "Без претплате",
  "premium.premiumManageStoreSubscription": "Претплатили сте се преко продавнице {store}. Тамо можете управљати претплатом или је отказати.",
  "premium.premiumManageWebSubscription": "Управљајте претплатом, ажурирајте начин плаћања или откажите.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Обнавља се {date}",
  "premium.premiumSubscribeAnnual": "Годишње — 9,99 €/година",
  "premium.premiumSubscribedOn": "Претплаћено преко {platform}",
  "premium.premiumSubscribedOnWeb": "Претплаћено преко веба",
  "premium.premiumSubscribeMonthly": "Месечно — 1,99 €/месец",
  "premium.premiumSubscribeOnWeb": "Претплатите се сада да откључате све премиум функције.",
  "premium.premiumSubscriptionSuccess": "Ваша претплата је активирана! Уживајте у свим премиум функцијама.",
  "premium.premiumSubscriptionSuccessTitle": "Добродошли у Premium!",
  "premium.premiumWebappNotice": "Претплата преко веба тренутно није доступна.",
  "premium.pricePerMonth": "{price}/месец",
  "premium.pricePerYear": "{price}/година",
  "premium.purchasedNetatmoPro": "Претходно сте купили Netatmo Pro ({date}). Он вам даје приступ делу премиум функција. Претплатите се на једну од следећих понуда ако желите приступ свим премиум функцијама.",
  "premium.purchaseFailed": "Куповина није могла да се заврши. Покушајте поново.",
  "premium.restoreFailed": "Ваше куповине нису могле да се обнове. Покушајте поново.",
  "premium.restorePurchase": "Обнови куповину",
  "premium.savingsPercent": "Уштедите {percent}%",
  "premium.seePremium": "Погледај Premium",
  "premium.startFreeTrial": "Започните бесплатни пробни период",
  "premium.storeUnavailable": "Продавница тренутно није доступна. Покушајте поново касније.",
  "premium.subscribeNow": "Претплати се сада — без пробног периода",
  "premium.switchToPremium": "Пређи на SmartMixin Premium",
  "premium.thenPrice": "затим {price}",
  "providerHints.ambientWeatherApiKey": "Креирано у подешавањима налога на ambientweather.net.",
  "providerHints.davisApiSecret": "Приказује се само једном приликом креирања V2 API кључа — чувајте га безбедно.",
  "providerHints.davisV2ApiKey": "Са странице V2 API кључева на weatherlink.com.",
  "providerHints.ecowittApi": "Са странице API вашег Ecowitt налога.",
  "providerHints.ecowittApp": "Кључ апликације, такође из вашег Ecowitt налога.",
  "providerHints.myAcuriteCredentialsBanner": "Користите e-mail и лозинку вашег My AcuRite налога — не SmartMixin пријаву.",
  "providerHints.myAcuriteEmail": "E-mail вашег My AcuRite налога — не ваша SmartMixin пријава.",
  "providerHints.myAcuritePassword": "Лозинка вашег My AcuRite налога.",
  "providerHints.weatherflowToken": "Токен за личну употребу са tempestwx.com → подешавања → ауторизације података.",
  "providerHints.wundergroundEditKey": "Користи други кључ",
  "providerHints.wundergroundKey": "Дугачак низ знакова са странице API кључева вашег Weather Underground налога — не ваша лозинка за wunderground.com.",
  "providerHints.wundergroundKeyExample": "нпр. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API кључ проверен",
  "providerHints.wundergroundNoStationsNearby": "Није пронађена ниједна станица у близини. Покушајте да унесете ID станице директно.",
  "providerHints.wundergroundStationIdExample": "нпр. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Набавите свој Ambient Weather API кључ.",
  "providerIntro.davisStep2": "Набавите свој Davis V2 API кључ и API тајну.",
  "providerIntro.ecowittStep2": "Набавите свој Ecowitt API кључ и кључ апликације.",
  "providerIntro.getStarted": "Започните",
  "providerIntro.myAcuriteStep2": "Користите e-mail и лозинку свог постојећег My AcuRite налога.",
  "providerIntro.netatmoEnergyStep2": "Пријавите се на Netatmo када будете упитани — API кључ није потребан.",
  "providerIntro.netatmoWeatherStep2": "Пријавите се на Netatmo када будете упитани — API кључ није потребан.",
  "providerIntro.signupBanner": "Скоро готово — креирајте свој бесплатни SmartMixin налог за повезивање {provider}.",
  "providerIntro.step1": "Пријавите се на свој SmartMixin налог (НЕ на {provider}).",
  "providerIntro.step3EmailPassword": "Унесите их овде.",
  "providerIntro.step3KeyOrToken": "Налепите овде.",
  "providerIntro.step3OAuth": "Ауторизујте SmartMixin у искачућем прозору.",
  "providerIntro.step3Wunderground": "Налепите свој API кључ, затим изаберите оближњу станицу или унесите било који ID станице.",
  "providerIntro.stepOfTotal": "Корак {step} од {total}",
  "providerIntro.title": "Повежи {provider}",
  "providerIntro.weatherflowStep2": "Набавите свој лични Tempest токен.",
  "providerIntro.wundergroundBrowsePublic": "Немате станицу? Прегледајте јавне",
  "providerIntro.wundergroundFindNearby": "Пронађи станице у близини",
  "providerIntro.wundergroundOrEnterId": "Или унесите ID станице",
  "providerIntro.wundergroundStep2": "Набавите свој Weather Underground API кључ. Затим можете повезати било коју станицу — своју или јавну.",
  "reports.agroMeteorology": "Агрометеорологија",
  "reports.analysis": "Анализа",
  "reports.annualCumulativeRainfallComparison": "Поређење укупних годишњих падавина",
  "reports.annualHeatingDurationComparison": "Годишње поређење времена грејања",
  "reports.annualHeatingEfficiency": "Годишња учинковитост грејања",
  "reports.annualIndoorComparison": "Годишње поређење унутрашњег модула",
  "reports.annualOutdoorComparison": "Годишње поређење спољашњег модула",
  "reports.annualOutdoorReport": "Годишњи извештај о спољашњем модулу",
  "reports.annualReport": "Годишњи извештај",
  "reports.annualSolarReport": "Годишњи соларни извештај",
  "reports.annualWaterBalance": "Годишњи биланс воде",
  "reports.annualWaterBalanceCarryOver": "Пренеси из {year}. ({value})",
  "reports.annualWaterBalanceDescription": "Водени биланс (поједностављена верзија, користе се само киша и евапотранспирација) омогућава управљање водним ресурсима",
  "reports.avgHumidity": "Просечна влажност ваздуха",
  "reports.avgMaxTemperature": "Просечна T°max",
  "reports.avgMetric": "Просек – {metric}",
  "reports.avgMinTemperature": "Просечна T°min",
  "reports.avgPressure": "Просечна вредност ваздушног притиска",
  "reports.avgTemperature": "Просечна температура",
  "reports.chartsAndTable": "Дијаграми и табела",
  "reports.climateNormalPeriodOfRecord": "Период мерења ({years, plural, one {# година} few {# године} other {# година}})",
  "reports.climateNormals": "Климатске нормале",
  "reports.climateNormalStandardLabel": "Стандардна нормала ({period})",
  "reports.climateTrendPerDecade": "Тренд температуре: {value} по деценији током {years, plural, one {# године} few {# године} other {# година}}",
  "reports.coldestMonthRanking": "Најхладнији {month} у историји мерења",
  "reports.comfortable": "Угодна (45% {lessThan} влажност ваздуха ≤ 60%)",
  "reports.cumulativeRainfall": "Кумулативне падавине",
  "reports.cumulativeRainfallDescription": "Пратите укупне падавине које се акумулирају током изабраног периода.",
  "reports.dailyMaxRainfall": "Максималне дневне падавине",
  "reports.dataExport": "Извези податке",
  "reports.dataExportXlsxFormatDescription": "Извезите све ваше податке у ексел фајл (*.xlsx). Након што кликнете на дугме, након пар минута ћете добити мејл са обрађеним подацима.",
  "reports.daysOfData": "{days, plural, one {# дан} few {# дана} other {# дана}} података",
  "reports.daysWithFrost": "Дани са мразом",
  "reports.daysWithHeavyRain": "Дани са јаком кишом (≥ {threshold})",
  "reports.daysWithoutThaw": "Ледени дани",
  "reports.daysWithStrongFrost": "Дани са јаким мразом",
  "reports.emailSent": "Мејл је послат на вашу адресу е-поште",
  "reports.frostDays": "Мразни дани",
  "reports.grasslandTemperatureSum": "Температурна сума травњака",
  "reports.grasslandTemperatureSumDescription": "Ако сума од {threshold} буде премашена у пролеће, достигнут је одрживи почетак вегетације (важи за Европу)",
  "reports.growingDegreeDays": "Степен-дани раста",
  "reports.highPressure": "Антициклон (Просечна вредност притиска ≥ {threshold})",
  "reports.iceDays": "Ледени дани",
  "reports.indoorReport": "Извештај унутрашњег модула",
  "reports.keyFacts": "Важне чињенице",
  "reports.longestDrySpell": "Најдужи сушни период",
  "reports.longestRunOfRainyDays": "Број узастопних кишних дана",
  "reports.longestRunWithoutRun": "Број узастопних дана без кише",
  "reports.longestWetSpell": "Најдужи кишни период",
  "reports.lowPressure": "Низак притисак (просечна вредност притиска {lessThan} {threshold})",
  "reports.maxHumidity": "Максимална влажност",
  "reports.maxMetric": "Максимум – {metric}",
  "reports.maxPressure": "Највиши притисак",
  "reports.maxTemperature": "Највиша температура",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Максимална дневна амплитуда (/24H)",
  "reports.minHumidity": "Минимална влажност",
  "reports.minMetric": "Минимум – {metric}",
  "reports.minPressure": "Најнижи притисак",
  "reports.minTemperature": "Најнижа температура",
  "reports.minTempMagnitude24h": "Минимална дневна амплитуда (/24H)",
  "reports.monthlyAverageCountdown": "{days, plural, one {Још # дан} few {Још # дана} other {Још # дана}} овог месеца",
  "reports.monthlyAverageCountdownDetail": "Тада ће се појавити просек овог месеца и његов ранг.",
  "reports.monthlyAverageRule": "Месечни просеци и рангирања појављују се када календарски месец има забележено {days, plural, one {# дан} few {# дана} other {# дана}}.",
  "reports.monthlyHeatingEfficiency": "Месечна учинковитост грејања",
  "reports.monthlyOutdoorReport": "Месечни извештај спољашњег модула",
  "reports.monthlyReport": "Месечни извештај",
  "reports.monthlySolarReport": "Месечни соларни извештај",
  "reports.monthlyWindReport": "Месечни извештај о ветру",
  "reports.monthsOfData": "{months, plural, one {# месец} few {# месеца} other {# месеци}} података",
  "reports.numberOfDays": "Број дана",
  "reports.outdoorReport": "Извештај спољашњег модула",
  "reports.overviewSection": "Преглед",
  "reports.rainfall": "Падавине",
  "reports.rainyDays": "Дани са падавинама",
  "reports.recordClimatologicalDay": "Климатолошки дан (06–06 UTC)",
  "reports.recordClimDayBody": "Овде се киша сабира по календарском дану, од поноћи до поноћи по времену станице. Метеоролошке службе је сабирају од 06:00 до 06:00 UTC, па олуја око поноћи може учинити неки други дан најкишовитијим.",
  "reports.recordDailyRain": "Најкишовитији дан",
  "reports.recordFromHourlyReadings": "Из часовних мерења",
  "reports.recordHigh": "Рекордна врућина",
  "reports.recordLow": "Рекордна хладноћа",
  "reports.recordOfficialBody": "Метеоролошка служба објављује дневни максимум и минимум за ову станицу, очитане са максималног и минималног термометра. Они бележе кратке врхове које часовна мерења пропусте, па замењују вредности израчунате из часовних мерења.",
  "reports.recordOfficialValue": "Званична вредност",
  "reports.recordsAndClimatology": "Рекорди и клима",
  "reports.recordSheetTitle": "О овим рекордима",
  "reports.recordsSince": "Рекорди од {date}",
  "reports.recordWindGust": "Најјачи удар ветра",
  "reports.relativelyWet": "Релативно влажно (60% {lessThan} Влажност ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, one {# извештај} few {# извештаја} other {# извештаја}}",
  "reports.sendEmail": "Пошаљи мејл",
  "reports.summerDays": "Летњи дани",
  "reports.tableScrollRegion": "{title}, помера се хоризонтално",
  "reports.tooDry": "Сувише суво (Влажност ≤ 45%)",
  "reports.tooWet": "Превлажно (Влажност {greaterThan} 80%)",
  "reports.tropicalNights": "Тропске ноћи",
  "reports.unlockPremiumSubtitle": "Укључено уз SmartMixin Premium",
  "reports.unlockPremiumTitle": "Откључајте {count, plural, one {# премијум функцију} few {# премијум функције} other {# премијум функција}}",
  "reports.warmestMonthRanking": "Најтоплији {month} у историји мерења",
  "reports.waterBalance": "Биланс воде",
  "reports.yearsOfData": "{years, plural, one {# година} few {# године} other {# година}} података",
  "reports.yearToDateTemperatureComparison": "Поређење температуре од почетка године",
  "sensors.bgtSensors": "Црна кугла и WBGT",
  "sensors.cameraFeed": "Камера",
  "sensors.compareHumidity": "Упореди влажност",
  "sensors.compareMoisture": "Упореди влагу земље",
  "sensors.comparePm25": "Упореди PM2.5",
  "sensors.compareTemperatures": "Упореди температуре",
  "sensors.compareWaterTension": "Упореди тензију воде у земљишту",
  "sensors.depthByChannel": "Дубина по каналу",
  "sensors.heatStressExtreme": "Екстреман топлотни стрес",
  "sensors.heatStressModerate": "Умерен топлотни стрес",
  "sensors.heatStressNone": "Нема топлотног стреса",
  "sensors.heatStressStrong": "Јак топлотни стрес",
  "sensors.heatStressVeryStrong": "Веома јак топлотни стрес",
  "sensors.indoorClimate": "Унутрашња клима",
  "sensors.indoorCo2Levels": "Нивои CO2",
  "sensors.indoorTemperatureAndHumidity": "Температура и влажност",
  "sensors.leafWetnessByChannel": "Влажност листова по каналу",
  "sensors.lightningSensor": "Муња",
  "sensors.moistureByChannel": "Влага земље по каналу",
  "sensors.noDataAvailable": "Нема доступних података",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 по каналу",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Изаберите канал",
  "sensors.sensorDetailDescription": "Прегледајте историјске податке и трендове за канале сензора.",
  "sensors.sensorHistory": "Историја сензора",
  "sensors.soilConductivityByChannel": "Проводљивост по каналу",
  "sensors.soilTemperatureByChannel": "Температура земље по каналу",
  "sensors.strikesToday": "Удари данас",
  "sensors.temperatureByChannel": "Температура по каналу",
  "sensors.viewChart": "Прикажи график",
  "sensors.waterTensionByChannel": "Тензија воде у земљишту по каналу",
  "settings.appearance": "Изглед",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "арапски",
  "settings.bulgarian": "бугарски",
  "settings.catalan": "каталонски",
  "settings.chartGestures": "Гесте на дијаграму",
  "settings.chartGesturesDescription": "Преласком преко дијаграма мењате период, скупљањем прстима мењате временску скалу",
  "settings.choiceCount": "{count, plural, one {Доступно: #} few {Доступно: #} other {Доступно: #}}",
  "settings.contactUs": "Контактирајте нас",
  "settings.contactUsDescription": "Затражите помоћ или пошаљите повратну информацију",
  "settings.croatian": "хрватски",
  "settings.czech": "чешки",
  "settings.dailyDetailByPeriods": "Дневни детаљи по периодима",
  "settings.dailyDetailByPeriodsDescription": "Групиши 24 сата у ноћ, јутро, поподне и вече — иста подела коју користи дневни резиме.",
  "settings.danish": "дански",
  "settings.dark": "Тамна тема",
  "settings.dataDisplay": "Приказ података",
  "settings.dateAndTime": "Датум и време",
  "settings.donateButton": "Донирајте",
  "settings.donateDescription": "SmartMixin развија мали тим. Ако вам је користан, можете подржати његов развој једнократном донацијом у било ком износу. То је поклон — не мења ваш план нити откључава било какве функције.",
  "settings.donateSuccessBody": "Ваша донација помаже да SmartMixin настави да ради и да се унапређује. Искрено то ценимо.",
  "settings.donateSuccessTitle": "Хвала вам на подршци!",
  "settings.donateTitle": "Подржите SmartMixin",
  "settings.dragToReorder": "Превуците да промените редослед",
  "settings.dutch": "низоземски",
  "settings.english": "енглески",
  "settings.french": "француски",
  "settings.german": "немачки",
  "settings.gestures": "Гесте",
  "settings.greek": "грчки",
  "settings.hungarian": "мађарски",
  "settings.italian": "италијански",
  "settings.japanese": "јапански",
  "settings.korean": "корејски",
  "settings.language": "Језик",
  "settings.languageDescription": "Језик по избору",
  "settings.light": "Светла тема",
  "settings.measurementUnits": "Мерне јединице",
  "settings.netatmoDashboard": "Netatmo контролна табла",
  "settings.netatmoLayoutCards": "Листа картица",
  "settings.netatmoLayoutCardsDescription": "Једна картица по модулу, све у једном померању",
  "settings.netatmoLayoutClassic": "Класични",
  "settings.netatmoLayoutClassicDescription": "Две картице, клизање између модула",
  "settings.netatmoNewLayoutNotice": "Нови распоред: једна картица по модулу.",
  "settings.netatmoSwitchBackToClassic": "Назад на класични",
  "settings.netatmoSwitchToLayout": "Пребаци на: {layout}",
  "settings.norwegian": "норвешки",
  "settings.notificationsSection": "Обавештења",
  "settings.ongoingNotificationEnabled": "Омогући трајно обавештење",
  "settings.ongoingNotificationMetrics": "Приказане метрике",
  "settings.ongoingNotificationPermissionRequired": "Потребна је дозвола за обавештења",
  "settings.ongoingNotificationPreviewHint": "Преглед — укључите виџет да би се приказао",
  "settings.ongoingNotificationStatusBar": "Статусна трака",
  "settings.polish": "пољски",
  "settings.portuguese": "португалски",
  "settings.preferencesSection": "Поставке",
  "settings.privacyPolicy": "Политика приватности",
  "settings.russian": "руски",
  "settings.serbian": "српски",
  "settings.settings": "Подешавања",
  "settings.settingsPageTitle": "Подешавања - {page}",
  "settings.slovak": "словачки",
  "settings.smallDecimals": "Мали децимали",
  "settings.smallDecimalsDescription": "Приказуј децималне цифре у мањој величини",
  "settings.spanish": "шпански",
  "settings.statusBarWidget": "Виџет статусне траке",
  "settings.statusBarWidgetDescription": "Увек видљиви временски подаци",
  "settings.subscriptionSection": "Претплата",
  "settings.supportSection": "Подршка",
  "settings.swedish": "шведски",
  "settings.systemTheme": "Системска тема",
  "settings.termsOfService": "Услови коришћења",
  "settings.themeDarkShort": "Тамна",
  "settings.themeLightShort": "Светла",
  "settings.themeSystemShort": "Системска",
  "settings.turkish": "турски",
  "settings.ukrainian": "украјински",
  "settings.units": "Јединице",
  "settings.unitsDescription": "Мерне јединице приказане унутар апликације",
  "settings.update": "Ажурирај",
  "settings.windDirectionConvention": "Стрелица правца ветра",
  "settings.windDirectionConventionDescription": "Изаберите приказ стрелица правца ветра",
  "settings.windDirectionMeteorological": "Правац порекла",
  "settings.windDirectionMeteorologicalDescription": "Стрелица показује одакле ветар дува (метеоролошка конвенција)",
  "settings.windDirectionOceanographic": "Правац струјања",
  "settings.windDirectionOceanographicDescription": "Стрелица показује куда ветар дува (океанографска конвенција)",
  "stations.addAStation": "Додај станицу",
  "stations.addToFavorites": "Додај у фаворите",
  "stations.addYourOwnStation": "Додајте своју станицу",
  "stations.clearRecentLocations": "Очистити све",
  "stations.clearSearch": "Обриши претрагу",
  "stations.currentLocation": "Тренутна локација",
  "stations.customizedStationName": "Прилагођено име станице",
  "stations.favoriteLocations": "Фаворити",
  "stations.favoriteLocationsEmpty": "Можете да додате до 5 омиљених локација.",
  "stations.favoriteStations": "Омиљене станице",
  "stations.filterStationDescription": "Не приказуј станице са непоузданим мерењима.",
  "stations.filterStations": "Филтрирај станице",
  "stations.filterStationSourceDescription": "Изаберите добављаче станица које желите да прикажете на мапи",
  "stations.findStationsNearYou": "Пронађите станице у близини",
  "stations.hiddenStations": "Скривене станице",
  "stations.hiddenStationsDescription": "Станицу можете поново да прикажете додиром на икону ока поред ње.",
  "stations.hideStationNamed": "Сакриј {station}",
  "stations.lastSeen": "последњи пут {time}",
  "stations.loadingStation": "Учитавање станице…",
  "stations.location": "Локација",
  "stations.locationAddedToFavorites": "Локација је додата у фаворите",
  "stations.locationNotGranted": "Дозвола за локацију није одобрена. Молимо вас да дозволите приступ вашој локацији у подешавањима уређаја.",
  "stations.locationRemovedFromFavorites": "Локација уклоњена из фаворита",
  "stations.locations": "Локације",
  "stations.locationUnavailable": "Није могуће утврдити вашу локацију. Проверите подешавања уређаја.",
  "stations.maxFavoriteLocationsReached": "Можете да имате највише 5 омиљених локација. Уклоните једну да бисте додали другу.",
  "stations.modifyFavoriteStations": "Измените омиљене станице",
  "stations.modifyFavoriteStationsDescription": "Можете да промените редослед омиљених станица превлачењем. Такође их можете уклонити са листе.",
  "stations.myLocation": "Моја локација",
  "stations.nearbyWeatherStations": "Оближње метео-станице",
  "stations.noLocationsFound": "Нису пронађене локације",
  "stations.noLongerReported": "Више није на списку",
  "stations.noLongerReportedBy": "{provider}: није на списку од {date}",
  "stations.noSearchResults": "Ниједан чланак не одговара вашој претрази",
  "stations.noStationsFound": "Нису пронађене станице",
  "stations.noWeatherStationYet": "Још увек немате метеостаницу.",
  "stations.recentLocations": "Недавни",
  "stations.recentLocationsEmpty": "Недавна историја је празна.",
  "stations.removeFromFavorites": "Уклони из омиљених",
  "stations.removeStationNamed": "Уклони {station} из омиљених",
  "stations.reorderStationNamed": "Премести {station}",
  "stations.searchForLocation": "Потражи локацију",
  "stations.searchForWeatherStation": "Потражи метеостаницу",
  "stations.searchResults": "Резултати претраге",
  "stations.searchResultsEmpty": "Нема резултата.",
  "stations.searchResultsFound": "{count, plural, one {Пронађен # резултат} few {Пронађена # резултата} other {Пронађено # резултата}}",
  "stations.searchStationsDescription": "Унесите град, адресу или назив места да бисте пронашли метеоролошке станице у близини.",
  "stations.searchStationsHint": "Користите траку за претрагу изнад да бисте открили метеоролошке станице било где у свету.",
  "stations.selectStationForComparison": "Изаберите станицу за поређење",
  "stations.stationAddedToFavorites": "Станица је додата у омиљене",
  "stations.stationCount": "{count, plural, one {# станица} few {# станице} other {# станица}}",
  "stations.stationInformation": "Информације о станици",
  "stations.stationName": "Назив станице",
  "stations.stationObservationsDescription": "Прикажите најновија запажања са метеоролошких станица",
  "stations.stationRemovedFromFavorites": "Станица је уклоњена из омиљених",
  "stations.stationsLoading": "Учитавање метеостаница",
  "stations.stationsNear": "Станице у близини: {place}",
  "stations.stationType": "Тип станице",
  "stations.statusOffline": "Ван мреже",
  "stations.statusOnline": "На мрежи",
  "stations.statusStale": "Застарело",
  "stations.tryAnotherLocation": "Нисмо могли да пронађемо метеоролошке станице у близини ове локације. Покушајте да претражујете у другом подручју.",
  "stations.unhideStationNamed": "Поново прикажи {station}",
  "stations.weatherStation": "Метеостаница",
  "stations.weatherStationCount": "{count, plural, one {# метеостаница} few {# метеостанице} other {# метеостаница}}",
  "stations.weatherStations": "Метеостанице",
  "stations.welcomeConnectService": "Поседујете метеоролошку станицу? Повежите свој сервис",
  "stations.welcomeSubtitle": "Ваше време, све на једном месту",
  "thermostat.away": "Одсутност",
  "thermostat.boilerOn": "Бојлер УКЉУЧЕН",
  "thermostat.hg": "Заштита од мраза",
  "thermostat.homeInformation": "Информације о кући",
  "thermostat.homeName": "Име куће",
  "thermostat.manualBoost": "Ручно повећање",
  "thermostat.manualSetpointUntil": "Ручна задата вредност до",
  "thermostat.noThermostatYet": "Немате термостат.",
  "thermostat.relay": "Релеј",
  "thermostat.room": "Просторија",
  "thermostat.rooms": "Просторије",
  "thermostat.smartThermostat": "Паметни термостат",
  "thermostat.smartValve": "Паметни вентил",
  "thermostat.whenBackHome": "Када се враћате кући?",
  "units.celsius": "Целзијус",
  "units.fahrenheit": "Фаренхајт",
  "units.inch": "Инчи",
  "units.inchOfMercury": "Инчи живиног стуба",
  "units.kelvin": "Келвин",
  "units.kilometerPerHour": "Километри на сат",
  "units.knot": "Чворови",
  "units.meterPerSecond": "Метри у секунди",
  "units.milePerHour": "Миље на сат",
  "units.millibar": "Милибари",
  "units.millimeter": "Милиметри",
  "units.millimeterOfMercury": "Милиметри живиног стуба",
  "weatherConditions.blizzard": "Мећава",
  "weatherConditions.blowingDust": "Узвитлана прашина",
  "weatherConditions.blowingSnow": "Вејавица",
  "weatherConditions.breezy": "Лаган ветар",
  "weatherConditions.clear": "Ведро",
  "weatherConditions.cloudy": "Облачно",
  "weatherConditions.drizzle": "Ромињање",
  "weatherConditions.flurries": "Слаб снег",
  "weatherConditions.foggy": "Магла",
  "weatherConditions.freezingDrizzle": "Ледено ромињање",
  "weatherConditions.freezingRain": "Ледена киша",
  "weatherConditions.frigid": "Јака хладноћа",
  "weatherConditions.hail": "Град",
  "weatherConditions.haze": "Сува мутноћа",
  "weatherConditions.heavyRain": "Јака киша",
  "weatherConditions.heavySnow": "Јак снег",
  "weatherConditions.hot": "Врућина",
  "weatherConditions.hurricane": "Ураган",
  "weatherConditions.isolatedThunderstorms": "Изоловане грмљавине",
  "weatherConditions.mixedRainAndHail": "Киша и град",
  "weatherConditions.mostlyClear": "Претежно ведро",
  "weatherConditions.mostlyCloudy": "Претежно облачно",
  "weatherConditions.mostlySunny": "Претежно сунчано",
  "weatherConditions.notAvailable": "Временски услови нису доступни",
  "weatherConditions.partlyCloudy": "Делимично облачно",
  "weatherConditions.rain": "Киша",
  "weatherConditions.rainSleet": "Киша и ледене куглице",
  "weatherConditions.rainSnow": "Киша и снег",
  "weatherConditions.scatteredShowers": "Местимични пљускови",
  "weatherConditions.scatteredSnowShowers": "Местимични снежни пљускови",
  "weatherConditions.scatteredThunderstorms": "Местимичне грмљавине",
  "weatherConditions.showers": "Пљускови",
  "weatherConditions.sleet": "Ледене куглице",
  "weatherConditions.smoke": "Дим",
  "weatherConditions.snow": "Снег",
  "weatherConditions.snowShowers": "Снежни пљускови",
  "weatherConditions.strongStorms": "Јаке грмљавине",
  "weatherConditions.sunny": "Сунчано",
  "weatherConditions.thunderstorms": "Грмљавине",
  "weatherConditions.tornado": "Торнадо",
  "weatherConditions.tropicalStorm": "Тропска олуја",
  "weatherConditions.windy": "Ветровито",
  "weatherConditions.wintryMix": "Мешовите зимске падавине",
  "weatherMap.clusterMarkerName": "{metric} {value}, медијана од {count, plural, one {# станице} few {# станице} other {# станица}}, увећај",
  "weatherMap.legendHeavy": "Јак",
  "weatherMap.legendLight": "Слаб",
  "weatherMap.legendLightningHelp": "Боја приказује старост сваке муње у последњих {minutes} минута — најновије белом, најстарије тамноцрвеном.",
  "weatherMap.legendNewest": "Најновије",
  "weatherMap.legendOldest": "Најстарије",
  "weatherMap.legendStationsHelp": "Боја ознаке одражава вредност изабране величине.",
  "weatherMap.lightningDataAttribution": "Подаци о муњама: Blitzortung.org",
  "weatherMap.lightningStrikes": "Удари муња",
  "weatherMap.lightningStrikesDescription": "Прикажи ударе муња у реалном времену на карти",
  "weatherMap.mapLayers": "Слојеви карте",
  "weatherMap.mapLegend": "Легенда мапе",
  "weatherMap.mapMode": "Режим карте",
  "weatherMap.mapNameForecast": "Прогностичка карта, {model}, {variable}",
  "weatherMap.mapNameObservations": "Метеокарта, осматрања",
  "weatherMap.modeForecast": "Прогноза",
  "weatherMap.modeObservations": "Осматрања",
  "weatherMap.radarDataAttribution": "Подаци радара: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.radarTime": "Време радарског снимка",
  "weatherMap.rainRadar": "Радар падавина",
  "weatherMap.rainRadarDescription": "Прикажите преклапање радара за кишу на мапи",
  "weatherMap.resetBearing": "Превуците да бисте ротирали карту, кликните да бисте је вратили ка северу",
  "weatherMap.showingForecast": "Приказана прогноза: {model}, {variable}",
  "weatherMap.signInForecastBody": "GFS карте су бесплатне уз SmartMixin налог. Уз Premium доступно је више модела.",
  "weatherMap.signInForecastTitle": "Пријавите се да бисте видели прогностичке карте",
  "weatherMap.stationMarkerName": "{metric} {value}, једна станица",
  "weatherMap.stationMarkersHint": "Стрелицама се крећете између станица",
  "weatherMap.stationMarkerWindValue": "{speed}, смер {direction}",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain је додатни извор података који се обезбеђује преко Tempest Weather System-а, који покреће технологија Nearcast. Подаци о NC Rain су процена просечне акумулације падавина око вашег Tempest-а на нивоу суседства",
  "weatherMap.weatherMap": "Метеокарта",
  "weatherMap.weatherMapMetaDescription": "SmartMixin нуди интерактивне мапе времена и радара за временске услове широм света.",
  "weatherMap.zoomIn": "Увећај",
  "weatherMap.zoomOut": "Умањи",
  "weatherWarnings.activeNow": "Тренутно активна",
  "weatherWarnings.agencyMessage": "Порука метеоролошке службе",
  "weatherWarnings.areaCovered": "Обухваћено подручје",
  "weatherWarnings.areaThisLocation": "{area} (ова локација)",
  "weatherWarnings.areaYourStation": "{area} (ваша метеостаница)",
  "weatherWarnings.badgeLabel": "{others, plural, =0 {Званично упозорење, {severity}: {hazard}} one {Званично упозорење, {severity}: {hazard}, и још #} few {Званично упозорење, {severity}: {hazard}, и још #} other {Званично упозорење, {severity}: {hazard}, и још #}}",
  "weatherWarnings.badgeLabelUpcoming": "{others, plural, =0 {Предстојеће званично упозорење, {severity}: {hazard}} one {Предстојеће званично упозорење, {severity}: {hazard}, и још #} few {Предстојеће званично упозорење, {severity}: {hazard}, и још #} other {Предстојеће званично упозорење, {severity}: {hazard}, и још #}}",
  "weatherWarnings.crumb": "Званична упозорења",
  "weatherWarnings.emptyBody": "Национална метеоролошка служба нема важећих упозорења за ово место. Поново проверавамо на сваких неколико минута.",
  "weatherWarnings.emptyTitle": "Нема званичних упозорења",
  "weatherWarnings.ended": "Завршено",
  "weatherWarnings.endedAt": "Ово упозорење је завршено {time}.",
  "weatherWarnings.errorBody": "Проверите везу. Поново покушавамо на сваких неколико минута.",
  "weatherWarnings.errorTitle": "Учитавање званичних упозорења није успело",
  "weatherWarnings.fromTime": "Од {time}",
  "weatherWarnings.hazardAirQuality": "Квалитет ваздуха",
  "weatherWarnings.hazardAvalanche": "Лавине",
  "weatherWarnings.hazardCoastalEvent": "Опасности на обали",
  "weatherWarnings.hazardFlood": "Поплаве",
  "weatherWarnings.hazardFog": "Магла",
  "weatherWarnings.hazardForestFire": "Шумски пожари",
  "weatherWarnings.hazardHighTemperature": "Високе температуре",
  "weatherWarnings.hazardLowTemperature": "Ниске температуре",
  "weatherWarnings.hazardOther": "Друга опасност",
  "weatherWarnings.hazardRain": "Киша",
  "weatherWarnings.hazardSnowIce": "Снег и лед",
  "weatherWarnings.hazardThunderstorm": "Грмљавине",
  "weatherWarnings.hazardUv": "УВ зрачење",
  "weatherWarnings.hazardWind": "Ветар",
  "weatherWarnings.hideHazards": "Сакриј појаве",
  "weatherWarnings.issuedBy": "Издао: {sender}",
  "weatherWarnings.lastUpdate": "Последње ажурирање: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {Карта обухваћеног подручја: {area}.} other {Карта обухваћених подручја, укупно #. Истакнуто: {area}.}}",
  "weatherWarnings.mapLabelNoHighlight": "{count, plural, =1 {Карта обухваћеног подручја.} other {Карта обухваћених подручја, укупно #.}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {Карта није доступна. Подручје је наведено испод.} other {Карта није доступна. Списак подручја (#) налази се испод.}}",
  "weatherWarnings.moreHazards": "+ још {count}: {hazards}",
  "weatherWarnings.notInLanguage": "Није доступно на језику: {language}. Приказано онако како га је објавила метеоролошка служба.",
  "weatherWarnings.openOn": "Отвори на {site}",
  "weatherWarnings.otherAreas": "{count, plural, one {+ још # подручје} few {+ још # подручја} other {+ још # подручја}}",
  "weatherWarnings.severityExtreme": "Екстремна",
  "weatherWarnings.severityFrom": "{severity} од {time}",
  "weatherWarnings.severityMinor": "Ниска",
  "weatherWarnings.severityModerate": "Умерена",
  "weatherWarnings.severityNow": "{severity} сада",
  "weatherWarnings.severitySevere": "Озбиљна",
  "weatherWarnings.severityUntil": "{severity} до {time}",
  "weatherWarnings.showAllAreas": "{count, plural, one {Прикажи # подручје} few {Прикажи сва # подручја} other {Прикажи свих # подручја}}",
  "weatherWarnings.showAllOnMap": "{count, plural, one {Прикажи # подручје на карти} few {Прикажи сва # подручја на карти} other {Прикажи свих # подручја на карти}}",
  "weatherWarnings.showHazards": "Прикажи појаве",
  "weatherWarnings.showPeriods": "{count, plural, one {Прикажи # период} few {Прикажи сва # периода} other {Прикажи свих # периода}}",
  "weatherWarnings.source": "Извор: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, затим {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# званично упозорење о времену} few {# званична упозорења о времену} other {# званичних упозорења о времену}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity}: {range}",
  "weatherWarnings.title": "Званична упозорења о времену",
  "weatherWarnings.todayAt": "данас у {time}",
  "weatherWarnings.tomorrow": "Сутра",
  "weatherWarnings.tomorrowAt": "сутра у {time}",
  "weatherWarnings.upcoming": "Предстојећа",
  "weatherWarnings.viewAll": "Сва званична упозорења",
  "weatherWarnings.whatToDo": "Шта урадити"
}
